import { useCallback, useEffect, useRef, useState } from 'react'
import {
  Breadcrumb,
  Button,
  ButtonGroup,
  Card,
  Col,
  Dropdown,
  Form,
  InputGroup,
  ListGroup,
  Modal,
  Row,
  Spinner,
} from 'react-bootstrap'
import { FormattedMessage, defineMessages, useIntl } from 'react-intl'
import { useDisclourse } from '../../hooks/useDisclourse'
import { Tooltip } from 'react-tooltip'
import { AsideMenuPolicies } from './components/AsideMenuPolicies'
import { ModalAddPolice } from './components/ModalAddPolice'
import { useApolloClient, useLazyQuery, useMutation, useQuery } from '@apollo/client'
import { GET_ALL_POLICIES_LIST, GET_ALL_POLICIES_TOTALS } from '../../gql/queries/policiesApiQueries'
import { ModalHealthSherpaSearch } from './components/ModalHealthSherpaSearch'
import { toast } from 'react-toastify'
import { IResPoliciesAPI, NodePolicy } from '../../types/policiesApi'
import { hasPermission, parseId } from '../../helpers'
import { Badge } from 'react-bootstrap'
import { ALL_PERMISSIONS } from '../../helpers/consts'
import { FEATURE_SHOW_EZLYNX_COLUMN } from '../../helpers/appConfig'
import { getPolicyFormKind, isAcaKind } from '../../helpers/policyFormKind'
import moment from 'moment'
import { ModalPreview } from './components/ModalPreview'
import { BadgeStatePolicy } from '../onePolicy/components/BadgeStatePolicy'
import { InfoClientPolicy } from './components/InfoClientPolicy'
import {
  METAL_LEVELS,
  SIZE_PAGE_DEFAULT,
  INITIAL_POLICY_FILTERS,
  IMMIGRATION_STATUS_CHOICES,
  DOCUMENT_STATUS_OPTIONS,
  PAYMENT_STATUS_OPTIONS,
  getDocumentVariant,
  getPaymentVariant,
  getBadgeTextColor,
  getCarrierStatusVariant,
} from '../../helpers/consts'
import { cleanVariables, PaginationUtils } from '../shared/PaginationUtils'

import {
  BLOCK_POLICY,
  COMPLETE_POLICY,
  EDIT_POLICY,
  MARK_POLICIES_PAID,
  UNPAID_TO_ADVISOR,
  CHARGEBACK_TO_ADVISOR,
  UNCHARGEBACK_TO_ADVISOR,
  SYNC_POLICY_TO_HEALTH_SHERPA,
} from '../../gql/mutations/policyMutation'
import {
  AllPolicyStatusesData,
  IResBlockedPolicyApi,
  IResCompletedPolicyApi,
  IResMarkPoliciesPaidApi,
  IResUpdatePolicyApi,
} from '../../types/policies'

import { PaginationSection } from '../shared/PaginationSection'
import { useNavigate } from 'react-router-dom'
import { GET_ALL_POLICIES_STATUSES } from '../../gql/queries/policiesQueries'
import { GET_ALL_SIGNATURE_FORMS_LIST } from '../../gql/queries/signatureFormsApiQueries'
import { GET_ALL_STATES_EU_LIST } from '../../gql/queries/statesEUQuery'
import { GET_ASSIGNMENT_USERS_LIST } from '../../gql/queries/usersQuery'
import { GET_ALL_CARRIERS_LIST } from '../../gql/queries/carriersQuery'
import { GET_ALL_POLICY_TYPE_CATEGORIES } from '../../gql/queries/policyTypesQuery'
import { GET_ALL_LEAD_SOURCES } from '../../gql/queries/leadSourceQuery'
import { GET_MY_POLICY_FILTERS } from '../../gql/queries/policyFiltersQueries'
import { ModalFilters } from './components/ModalFilters'
import { PolicyFilters, PolicySavedFilter } from './policiesTypes'
import { buildPolicyExportParams } from './policyExportParams'
import { getColorByStatus, getTitleByStatus } from '../shared/utils'
import { ModalQuickUpdates } from './components/ModalQuickUpdates'
import { ModalNotes } from '../onePolicy/components/ModalNotes'
import { ModalCancelPolicy } from '../onePolicy/components/ModalCancelPolicy'
import { ModalAssignAgentPolicy } from '../onePolicy/components/ModalAssignAgentPolicy'
import { ModalViewLogs } from './components/ModalViewLogs'
import { useGetUser } from '../../store/userStore'
import { URL } from '../../gql/client'
import { ModalDuplicatePolicy } from '../onePolicy/components/ModalDuplicatePolicy'
import { AgentInfoTooltip } from '../shared/AgentInfoTooltip'
import { UserAvatar } from '../../components/UserAvatar'
import { AppliedFiltersList } from './components/AppliedFiltersList'
import { IResAllUsers } from '../oneUser/oneUserTypes'
import { GET_ALL_USERS_FILTER } from '../../gql/queries/usersQuery'
import { useStaticCatalog } from '../../hooks/useStaticCatalog'
import { ModalReassignPolicies } from './components/ModalReassignPolicies'
import { ModalUpdatePolicies } from './components/ModalUpdatePolicies'
import { ModalUpdatePoliciesByCarrier } from './components/ModalUpdatePoliciesByCarrier'
import { CarrierImportHistory } from './components/CarrierImportHistory'
import { ModalViewCarrierImportBatch } from './components/ModalViewCarrierImportBatch'
import { ModalCarrierStatusDetails } from './components/ModalCarrierStatusDetails'
import { ModalMemberIdCard } from './components/ModalMemberIdCard'
import { ModalACAVerification } from '../onePolicy/components/ModalACAVerification'
import { ModalImportPolicies } from './components/ModalImportPolicies'
import { EZLynxSyncBadge } from '../leads/components/EZLynxSyncBadge'
import {
  CREATE_POLICY_FILTER,
  DELETE_POLICY_FILTER,
  UPDATE_POLICY_FILTER,
} from '../../gql/mutations/policyFilterMutations'
const MEDICARE_ALLOWED_IMMIGRATION_STATUSES = ['CITIZEN', 'RESIDENT']

const isMedicareEligiblePolicy = (nodePolicy: any) => {
  const holder = nodePolicy?.holderMember
  if (!holder || !holder.dateBirth) {
    // console.log('Sync HS Hidden: No holder or DOB', nodePolicy.id)
    return false
  }

  const age = moment().diff(moment(holder.dateBirth), 'years')
  const validStatus = holder.immigrationStatus && MEDICARE_ALLOWED_IMMIGRATION_STATUSES.includes(holder.immigrationStatus.toUpperCase())

  const isEligible = age >= 64 && validStatus
  if (!isEligible) {
    console.log(`Sync HS Hidden for ${holder.firstName}: age=${age}, status=${holder.immigrationStatus}`)
  }

  return isEligible
}



// Hook convertido a lazy loading selectivo - solo carga las queries necesarias
interface LoadFilterOptions {
  loadUsers?: boolean
  loadAgents?: boolean
  loadSignatureForms?: boolean
  loadCarriers?: boolean
  loadStates?: boolean
  loadPolicyTypes?: boolean
  loadLeadSources?: boolean
  unrestrictedAssignmentUsers?: boolean
}

export const useLoadFilterData = (options: LoadFilterOptions) => {
  const intl = useIntl()
  const client = useApolloClient()

  const fetchUsers = useCallback(
    () =>
      client
        .query({
          query: GET_ASSIGNMENT_USERS_LIST,
          variables: { assignmentCandidates: !options.unrestrictedAssignmentUsers },
          fetchPolicy: 'network-only',
        })
        .then((res) => res.data),
    [client, options.unrestrictedAssignmentUsers]
  )
  const usersCatalog = useStaticCatalog(
    options.unrestrictedAssignmentUsers ? 'all-users-list-unrestricted' : 'all-users-list',
    !!options.loadUsers,
    fetchUsers
  )

  const fetchAgents = useCallback(
    () =>
      client
        .query<IResAllUsers>({
          query: GET_ALL_USERS_FILTER,
          variables: { requireNpn: true },
          fetchPolicy: 'network-only',
        })
        .then((res) => res.data),
    [client]
  )
  const agentsCatalog = useStaticCatalog('agents-with-npn', !!options.loadAgents, fetchAgents)

  const fetchSignatureForms = useCallback(
    () =>
      client
        .query({ query: GET_ALL_SIGNATURE_FORMS_LIST, fetchPolicy: 'network-only' })
        .then((res) => res.data),
    [client]
  )
  const signatureFormsCatalog = useStaticCatalog(
    'signature-forms-active',
    !!options.loadSignatureForms,
    fetchSignatureForms
  )

  const fetchCarriers = useCallback(
    () =>
      client
        .query({ query: GET_ALL_CARRIERS_LIST, fetchPolicy: 'network-only' })
        .then((res) => res.data),
    [client]
  )
  const carriersCatalog = useStaticCatalog('carriers-list', !!options.loadCarriers, fetchCarriers)

  const fetchStates = useCallback(
    () =>
      client
        .query({ query: GET_ALL_STATES_EU_LIST, fetchPolicy: 'network-only' })
        .then((res) => res.data),
    [client]
  )
  const statesCatalog = useStaticCatalog('states-eu', !!options.loadStates, fetchStates)

  const fetchPolicyTypes = useCallback(
    () =>
      client
        .query({ query: GET_ALL_POLICY_TYPE_CATEGORIES, fetchPolicy: 'network-only' })
        .then((res) => res.data),
    [client]
  )
  const policyTypesCatalog = useStaticCatalog(
    'policy-type-categories',
    !!options.loadPolicyTypes,
    fetchPolicyTypes
  )

  const fetchLeadSources = useCallback(
    () =>
      client
        .query({
          query: GET_ALL_LEAD_SOURCES,
          variables: { category: 'Policy', enabled: true },
          fetchPolicy: 'network-only',
        })
        .then((res) => res.data),
    [client]
  )
  const leadSourcesCatalog = useStaticCatalog(
    'lead-sources-policy',
    !!options.loadLeadSources,
    fetchLeadSources
  )

  if (usersCatalog.error) toast.error(intl.formatMessage(M.errLoadUsers))
  if (agentsCatalog.error) toast.error(intl.formatMessage(M.errLoadAgents))
  if (signatureFormsCatalog.error) toast.error(intl.formatMessage(M.errLoadSignatureForms))
  if (carriersCatalog.error) toast.error(intl.formatMessage(M.errLoadCarriers))
  if (statesCatalog.error) toast.error(intl.formatMessage(M.errLoadStates))
  if (policyTypesCatalog.error) toast.error(intl.formatMessage(M.errLoadPolicyTypes))
  if (leadSourcesCatalog.error) toast.error(intl.formatMessage(M.errLoadLeadSources))

  return {
    dataUsers: usersCatalog.data,
    dataAgents: agentsCatalog.data,
    dataSignatureForms: signatureFormsCatalog.data,
    dataCarriers: carriersCatalog.data,
    dataStates: statesCatalog.data,
    dataPolicyTypes: policyTypesCatalog.data,
    dataLeadSources: leadSourcesCatalog.data,
    loadingUsers: usersCatalog.loading,
    loadingAgents: agentsCatalog.loading,
    loadingSignatureForms: signatureFormsCatalog.loading,
    loadingCarriers: carriersCatalog.loading,
    loadingStates: statesCatalog.loading,
    loadingPolicyTypes: policyTypesCatalog.loading,
    loadingLeadSources: leadSourcesCatalog.loading,
  }
}

export function useLocalStorage<T>(key: string, initialValue: T) {
  const [storedValue, setStoredValue] = useState<T>(() => {
    try {
      const item = window.localStorage.getItem(key)
      return item ? (JSON.parse(item) as T) : initialValue
    } catch {
      return initialValue
    }
  })

  useEffect(() => {
    try {
      window.localStorage.setItem(key, JSON.stringify(storedValue))
    } catch {
      // puede fallar en modo incógnito
    }
  }, [key, storedValue])

  return [storedValue, setStoredValue] as const
}

// Marca comercial y símbolos sueltos: no se traducen, pero se izan a const para no
// dejar literales sueltos en JSX (regla formatjs/no-literal-string-in-jsx).
const ezlynx = 'EZLynx'
const emDash = '—'

// New i18n keys introduced by PoliciesPage. Declared here so `formatjs extract`
// captures them (the `f()` helper wrapper below is not detected by the extractor).
// Reused ModalFilters/B2 keys (policies.list.filters.*) are already declared there.
const M = defineMessages({
  // New filter keys referenced by filtersConfig / dateRangeFilters via f()
  segAtRisk: { id: 'policies.list.filters.seg.atRisk', defaultMessage: 'At Risk' },
  filterAccountCreatedByClient: { id: 'policies.list.filters.field.accountCreatedByClient', defaultMessage: 'Account created by client' },
  filterHasCarrierAccountCreatedByClient: { id: 'policies.list.filters.field.hasCarrierAccount.createdByClient', defaultMessage: 'Has carrier account (created by client)' },
  drEffective: { id: 'policies.list.filters.dateRange.effective', defaultMessage: 'Effective Date' },
  drCreated: { id: 'policies.list.filters.dateRange.created', defaultMessage: 'Created Date' },
  drDocumentsDue: { id: 'policies.list.filters.dateRange.documentsDue', defaultMessage: 'Documents Due Date' },
  drCancellation: { id: 'policies.list.filters.dateRange.cancellation', defaultMessage: 'Cancellation Date' },
  drPaymentStatus: { id: 'policies.list.filters.dateRange.paymentStatus', defaultMessage: 'Payment Status Date' },
  drAdvisorPaid: { id: 'policies.list.filters.dateRange.advisorPaid', defaultMessage: 'Advisor Paid Date' },
  drAdvisorChargeback: { id: 'policies.list.filters.dateRange.advisorChargeback', defaultMessage: 'Advisor Chargeback Date' },
  drCarrierAsOf: { id: 'policies.list.filters.dateRange.carrierAsOf', defaultMessage: 'Carrier As-of Date' },
  // Page chrome
  wordPolicies: { id: 'policies.list.page.wordPolicies', defaultMessage: 'Policies' },
  btnExport: { id: 'policies.list.page.btn.export', defaultMessage: 'Export' },
  btnImport: { id: 'policies.list.page.btn.import', defaultMessage: 'Import' },
  btnReassign: { id: 'policies.list.page.btn.reassign', defaultMessage: 'Reassign' },
  btnUpdate: { id: 'policies.list.page.btn.update', defaultMessage: 'Update' },
  btnUpdateCount: { id: 'policies.list.page.btn.updateCount', defaultMessage: 'Update ({count})' },
  btnNewPolicy: { id: 'policies.list.page.btn.newPolicy', defaultMessage: 'New Policy' },
  btnMarking: { id: 'policies.list.page.btn.marking', defaultMessage: 'Marking...' },
  btnMarkPaidCount: { id: 'policies.list.page.btn.markPaidCount', defaultMessage: '{count, plural, one {Mark as Paid} other {Mark as Paid}} ({count})' },
  btnProcessing: { id: 'policies.list.page.btn.processing', defaultMessage: 'Processing...' },
  btnUnpaidCount: { id: 'policies.list.page.btn.unpaidCount', defaultMessage: 'Unpaid ({count})' },
  btnChargebackCount: { id: 'policies.list.page.btn.chargebackCount', defaultMessage: 'Chargeback ({count})' },
  btnUnchargebackCount: { id: 'policies.list.page.btn.unchargebackCount', defaultMessage: 'Unchargeback ({count})' },
  menuTitle: { id: 'policies.list.page.menu.title', defaultMessage: 'Menu' },
  menuImportant: { id: 'policies.list.page.menu.important', defaultMessage: 'Important' },
  menuReminders: { id: 'policies.list.page.menu.reminders', defaultMessage: 'Reminders' },
  menuArchived: { id: 'policies.list.page.menu.archived', defaultMessage: 'Archived' },
  menuImportHistory: { id: 'policies.list.page.menu.importHistory', defaultMessage: 'Carrier Import History' },
  cardAllPolicies: { id: 'policies.list.page.card.allPolicies', defaultMessage: 'All Policies' },
  cardCompleted: { id: 'policies.list.page.card.completed', defaultMessage: 'Completed' },
  cardCompletedPolicies: { id: 'policies.list.page.card.completedPolicies', defaultMessage: 'Completed Policies' },
  cardInProcess: { id: 'policies.list.page.card.inProcess', defaultMessage: 'In Process' },
  cardInProcessPolicies: { id: 'policies.list.page.card.inProcessPolicies', defaultMessage: 'In-Process Policies' },
  cardCanceled: { id: 'policies.list.page.card.canceled', defaultMessage: 'Canceled' },
  cardCanceledPolicies: { id: 'policies.list.page.card.canceledPolicies', defaultMessage: 'Canceled Policies' },
  applicants: { id: 'policies.list.page.applicants', defaultMessage: 'Applicants' },
  effectiveYear: { id: 'policies.list.page.effectiveYear', defaultMessage: 'Effective year:' },
  phQuery: { id: 'policies.list.page.phQuery', defaultMessage: 'Type your query here...' },
  ariaSearch: { id: 'policies.list.page.ariaSearch', defaultMessage: 'Search policies' },
  btnSearch: { id: 'policies.list.page.btn.search', defaultMessage: 'Search' },
  btnFilter: { id: 'policies.list.page.btn.filter', defaultMessage: 'Filter' },
  searchByMembers: { id: 'policies.list.page.searchByMembers', defaultMessage: 'Search by family members:' },
  searchByMembersTooltip: { id: 'policies.list.page.searchByMembersTooltip', defaultMessage: 'Check this box if you need to search for policies by the name of the members.' },
  // C2 — table
  thAgentOwner: { id: 'policies.list.page.th.agentOwner', defaultMessage: 'Agent{br}Owner' },
  thClient: { id: 'policies.list.page.th.client', defaultMessage: 'Client' },
  thPolicy: { id: 'policies.list.page.th.policy', defaultMessage: 'Policy' },
  thAgentOfRecord: { id: 'policies.list.page.th.agentOfRecord', defaultMessage: 'Agent of Record' },
  emptyNoPolicies: { id: 'policies.list.page.emptyNoPolicies', defaultMessage: 'There are no policies currently added' },
  cellEffective: { id: 'policies.list.page.cell.effective', defaultMessage: 'Effective date: {date}' },
  titleApplicants: { id: 'policies.list.page.titleApplicants', defaultMessage: '{count, plural, one {# Applicant} other {# Applicants}}' },
  cellMemberId: { id: 'policies.list.page.cell.memberId', defaultMessage: 'ID: {id}' },
  tooltipMoreInfo: { id: 'policies.list.page.tooltip.moreInfo', defaultMessage: 'More information:' },
  irProduct: { id: 'policies.list.page.ir.product', defaultMessage: 'Product:' },
  irProductValue: { id: 'policies.list.page.ir.productValue', defaultMessage: 'Policy' },
  irPlan: { id: 'policies.list.page.ir.plan', defaultMessage: 'Plan:' },
  irMetal: { id: 'policies.list.page.ir.metal', defaultMessage: 'Metal Level:' },
  irPremium: { id: 'policies.list.page.ir.premium', defaultMessage: 'Premium:' },
  irNpn: { id: 'policies.list.page.ir.npn', defaultMessage: 'NPN:' },
  irBlocked: { id: 'policies.list.page.ir.blocked', defaultMessage: 'Blocked:' },
  irIsDuplicate: { id: 'policies.list.page.ir.isDuplicate', defaultMessage: 'Is duplicate?' },
  irSubmitted: { id: 'policies.list.page.ir.submitted', defaultMessage: 'Submitted:' },
  irLastUpdate: { id: 'policies.list.page.ir.lastUpdate', defaultMessage: 'Last update:' },
  cellDocuments: { id: 'policies.list.page.cell.documents', defaultMessage: 'Documents:' },
  cellDocsDue: { id: 'policies.list.page.cell.docsDue', defaultMessage: 'Documents due date:' },
  cellPayment: { id: 'policies.list.page.cell.payment', defaultMessage: 'Payment:' },
  cellCarrier: { id: 'policies.list.page.cell.carrier', defaultMessage: 'Carrier:' },
  cellAgeIn: { id: 'policies.list.page.cell.ageIn', defaultMessage: 'AGE-IN' },
  cellDlq: { id: 'policies.list.page.cell.dlq', defaultMessage: 'DLQ' },
  cellAsOf: { id: 'policies.list.page.cell.asOf', defaultMessage: 'As of:' },
  cellPaidToAdvisor: { id: 'policies.list.page.cell.paidToAdvisor', defaultMessage: 'PAID TO ADVISOR' },
  cellChargeback: { id: 'policies.list.page.cell.chargeback', defaultMessage: 'CHARGEBACK' },
  cellAcaPrefix: { id: 'policies.list.page.cell.acaPrefix', defaultMessage: 'ACA: {label}' },
  daysLeft: { id: 'policies.list.page.cell.daysLeft', defaultMessage: '{count, plural, one {# day left} other {# days left}}' },
  // C3 — row action dropdown
  actPreview: { id: 'policies.list.page.act.preview', defaultMessage: 'Preview' },
  actGetMemberIdCard: { id: 'policies.list.idCard.title', defaultMessage: 'Get member ID card' },
  actSyncHs: { id: 'policies.list.page.act.syncHs', defaultMessage: 'Sync to HealthSherpa' },
  actMarkCompleted: { id: 'policies.list.page.act.markCompleted', defaultMessage: 'Mark as completed' },
  actMarkBlocked: { id: 'policies.list.page.act.markBlocked', defaultMessage: 'Mark as blocked' },
  actMarkUnblocked: { id: 'policies.list.page.act.markUnblocked', defaultMessage: 'Mark as unblocked' },
  actEdit: { id: 'policies.list.page.act.edit', defaultMessage: 'Edit' },
  actDuplicate: { id: 'policies.list.page.act.duplicate', defaultMessage: 'Duplicate' },
  actQuickUpdate: { id: 'policies.list.page.act.quickUpdate', defaultMessage: 'Quick update' },
  actAssignPolicy: { id: 'policies.list.page.act.assignPolicy', defaultMessage: 'Assign policy' },
  actAddReminder: { id: 'policies.list.page.act.addReminder', defaultMessage: 'Add reminder' },
  actAddNote: { id: 'policies.list.page.act.addNote', defaultMessage: 'Add Note' },
  actViewLogs: { id: 'policies.list.page.act.viewLogs', defaultMessage: 'View Logs' },
  actAcaVerification: { id: 'policies.list.page.act.acaVerification', defaultMessage: 'ACA Verification' },
  actMarkArchived: { id: 'policies.list.page.act.markArchived', defaultMessage: 'Mark as archived' },
  actMarkUnarchived: { id: 'policies.list.page.act.markUnarchived', defaultMessage: 'Mark as unarchived' },
  actMarkCancel: { id: 'policies.list.page.act.markCancel', defaultMessage: 'Mark as Cancel' },
  // C4 — inline confirm / export modals
  confirmPaidTitle: { id: 'policies.list.page.confirm.paidTitle', defaultMessage: 'Mark policies as paid' },
  confirmPaidBody: { id: 'policies.list.page.confirm.paidBody', defaultMessage: '{count, plural, one {Are you sure you want to mark # policy as paid to the advisor?} other {Are you sure you want to mark # policies as paid to the advisor?}}' },
  fieldPaidDate: { id: 'policies.list.page.confirm.paidDate', defaultMessage: 'Paid date' },
  btnConfirm: { id: 'policies.list.page.confirm.confirm', defaultMessage: 'Confirm' },
  confirmUnpaidTitle: { id: 'policies.list.page.confirm.unpaidTitle', defaultMessage: 'Unpaid to Advisor' },
  confirmUnpaidBody: { id: 'policies.list.page.confirm.unpaidBody', defaultMessage: '{count, plural, one {Are you sure you want to mark # policy as unpaid to advisor?} other {Are you sure you want to mark # policies as unpaid to advisor?}}' },
  confirmUnpaidNote: { id: 'policies.list.page.confirm.unpaidNote', defaultMessage: '{count, plural, one {This action will unmark this policy as paid to the advisor and remove the payment date from the records.} other {This action will unmark these policies as paid to the advisor and remove the payment date from the records.}}' },
  btnConfirmUnpaid: { id: 'policies.list.page.confirm.confirmUnpaid', defaultMessage: 'Confirm Unpaid' },
  confirmChargebackTitle: { id: 'policies.list.page.confirm.chargebackTitle', defaultMessage: 'Chargeback to Advisor' },
  confirmChargebackBody: { id: 'policies.list.page.confirm.chargebackBody', defaultMessage: '{count, plural, one {Mark # policy as chargeback to advisor.} other {Mark # policies as chargeback to advisor.}}' },
  fieldChargebackDate: { id: 'policies.list.page.confirm.chargebackDate', defaultMessage: 'Chargeback date' },
  btnConfirmChargeback: { id: 'policies.list.page.confirm.confirmChargeback', defaultMessage: 'Confirm Chargeback' },
  confirmRemoveTitle: { id: 'policies.list.page.confirm.removeTitle', defaultMessage: 'Remove Chargeback' },
  confirmRemoveBody: { id: 'policies.list.page.confirm.removeBody', defaultMessage: '{count, plural, one {Are you sure you want to remove chargeback from # policy?} other {Are you sure you want to remove chargeback from # policies?}}' },
  confirmRemoveNote: { id: 'policies.list.page.confirm.removeNote', defaultMessage: '{count, plural, one {This action will unmark this policy as chargeback and remove the chargeback date from the records.} other {This action will unmark these policies as chargeback and remove the chargeback date from the records.}}' },
  btnConfirmRemove: { id: 'policies.list.page.confirm.confirmRemove', defaultMessage: 'Confirm Remove Chargeback' },
  exportTitle: { id: 'policies.list.page.export.title', defaultMessage: 'Export Options' },
  exportPrevYear: { id: 'policies.list.page.export.prevYear', defaultMessage: 'Search for policies from the previous year' },
  exportPrevYearHint: { id: 'policies.list.page.export.prevYearHint', defaultMessage: 'If a policy has an effective date in {nextYear}, it will search for a matching policy in {year}' },
  exportNextYear: { id: 'policies.list.page.export.nextYear', defaultMessage: 'Search for policies from the next year (renewal)' },
  exportNextYearHint: { id: 'policies.list.page.export.nextYearHint', defaultMessage: 'If a policy has an effective date in {year}, it will search for a matching policy in {nextYear}' },
  exportIncludeMembers: { id: 'policies.list.page.export.includeMembers', defaultMessage: 'Include members' },
  exportIncludeMembersHint: { id: 'policies.list.page.export.includeMembersHint', defaultMessage: 'Adds a block of columns per member other than the holder (applicant, name, date of birth, gender, relationship and immigration status). The number of blocks matches the policy with the most members in the export' },
  btnExporting: { id: 'policies.list.page.export.exporting', defaultMessage: 'Exporting...' },
  cancel: { id: 'common.action.cancel', defaultMessage: 'Cancel' },
  // C5 — toasts
  errLoadUsers: { id: 'policies.list.page.toast.errLoadUsers', defaultMessage: 'Error loading users' },
  errLoadAgents: { id: 'policies.list.page.toast.errLoadAgents', defaultMessage: 'Error loading agents (users with NPN)' },
  errLoadSignatureForms: { id: 'policies.list.page.toast.errLoadSignatureForms', defaultMessage: 'Error loading signature forms' },
  errLoadCarriers: { id: 'policies.list.page.toast.errLoadCarriers', defaultMessage: 'Error loading carriers' },
  errLoadStates: { id: 'policies.list.page.toast.errLoadStates', defaultMessage: 'Error loading states' },
  errLoadPolicyTypes: { id: 'policies.list.page.toast.errLoadPolicyTypes', defaultMessage: 'Error loading policy types' },
  errLoadLeadSources: { id: 'policies.list.page.toast.errLoadLeadSources', defaultMessage: 'Error loading lead sources' },
  errLoadPolicyStatuses: { id: 'policies.list.page.toast.errLoadPolicyStatuses', defaultMessage: 'Error loading policy statuses' },
  filterNameRequired: { id: 'policies.list.page.toast.filterNameRequired', defaultMessage: 'Filter name is required.' },
  filterSaved: { id: 'policies.list.page.toast.filterSaved', defaultMessage: 'Filter saved.' },
  filterUpdated: { id: 'policies.list.page.toast.filterUpdated', defaultMessage: 'Filter updated.' },
  filterDeleted: { id: 'policies.list.page.toast.filterDeleted', defaultMessage: 'Filter deleted.' },
  unableSaveFilter: { id: 'policies.list.page.toast.unableSaveFilter', defaultMessage: 'Unable to save filter.' },
  unableUpdateFilter: { id: 'policies.list.page.toast.unableUpdateFilter', defaultMessage: 'Unable to update filter.' },
  unableDeleteFilter: { id: 'policies.list.page.toast.unableDeleteFilter', defaultMessage: 'Unable to delete filter.' },
  selectPaid: { id: 'policies.list.page.toast.selectPaid', defaultMessage: 'Select at least one policy to mark as paid.' },
  selectUnpaid: { id: 'policies.list.page.toast.selectUnpaid', defaultMessage: 'Select at least one policy to unpaid.' },
  selectChargeback: { id: 'policies.list.page.toast.selectChargeback', defaultMessage: 'Select at least one policy to mark as chargeback.' },
  selectRemoveChargeback: { id: 'policies.list.page.toast.selectRemoveChargeback', defaultMessage: 'Select at least one policy to remove chargeback.' },
  chargebackDateRequired: { id: 'policies.list.page.toast.chargebackDateRequired', defaultMessage: 'Please select a chargeback date.' },
  paidResult: { id: 'policies.list.page.toast.paidResult', defaultMessage: 'Policies marked as paid: {processed}. Skipped: {skipped}.' },
  noPaidResult: { id: 'policies.list.page.toast.noPaidResult', defaultMessage: 'No policies marked as paid. Processed: {processed}. Skipped: {skipped}.' },
  unpaidSuccess: { id: 'policies.list.page.toast.unpaidSuccess', defaultMessage: '{processed, plural, one {# policy marked as unpaid successfully.} other {# policies marked as unpaid successfully.}}' },
  unpaidAlreadySuffix: { id: 'policies.list.page.toast.unpaidAlreadySuffix', defaultMessage: '{skipped} already unpaid.' },
  unpaidAlreadyInfo: { id: 'policies.list.page.toast.unpaidAlreadyInfo', defaultMessage: '{skipped, plural, one {# policy was already marked as unpaid.} other {# policies were already marked as unpaid.}}' },
  errUnpaid: { id: 'policies.list.page.toast.errUnpaid', defaultMessage: 'Error marking policies as unpaid: {message}' },
  chargebackSuccess: { id: 'policies.list.page.toast.chargebackSuccess', defaultMessage: '{processed, plural, one {# policy marked as chargeback successfully.} other {# policies marked as chargeback successfully.}}' },
  chargebackAlreadySuffix: { id: 'policies.list.page.toast.chargebackAlreadySuffix', defaultMessage: '{skipped} already had chargeback.' },
  chargebackAlreadyInfo: { id: 'policies.list.page.toast.chargebackAlreadyInfo', defaultMessage: '{skipped, plural, one {# policy was already marked as chargeback.} other {# policies were already marked as chargeback.}}' },
  errChargeback: { id: 'policies.list.page.toast.errChargeback', defaultMessage: 'Error marking policies as chargeback: {message}' },
  unchargebackSuccess: { id: 'policies.list.page.toast.unchargebackSuccess', defaultMessage: '{processed, plural, one {# policy unmarked as chargeback successfully.} other {# policies unmarked as chargeback successfully.}}' },
  unchargebackAlreadySuffix: { id: 'policies.list.page.toast.unchargebackAlreadySuffix', defaultMessage: '{skipped} already had no chargeback.' },
  unchargebackAlreadyInfo: { id: 'policies.list.page.toast.unchargebackAlreadyInfo', defaultMessage: '{skipped, plural, one {# policy was already without chargeback.} other {# policies were already without chargeback.}}' },
  errUnchargeback: { id: 'policies.list.page.toast.errUnchargeback', defaultMessage: 'Error removing chargeback from policies: {message}' },
  policyUpdated: { id: 'policies.list.page.toast.policyUpdated', defaultMessage: 'Policy updated successfully' },
  syncedHs: { id: 'policies.list.page.toast.syncedHs', defaultMessage: 'Synced to HealthSherpa successfully' },
  errSyncHs: { id: 'policies.list.page.toast.errSyncHs', defaultMessage: 'Error syncing to HealthSherpa' },
  somethingWrong: { id: 'policies.list.addPolicy.toast.somethingWrong', defaultMessage: 'Something wrong' },
})

export const PoliciesPage = () => {
  const intl = useIntl()
  // Short helper for reusing existing catalog keys inline (id + English fallback).
  const f = (id: string, defaultMessage: string) => intl.formatMessage({ id, defaultMessage })
  const naValue = f('common.value.notAvailable', 'N/A')
  const nrValue = f('policies.list.preview.value.nr', 'N/R')
  // Metal level value → translated label (frontend const METAL_LEVELS; reuse filters.metal.* from B2).
  const metalLabelById: Record<string, [string, string]> = {
    '5': ['policies.list.filters.metal.platinum', 'Platinum'],
    '4': ['policies.list.filters.metal.gold', 'Gold'],
    '3': ['policies.list.filters.metal.silver', 'Silver'],
    '2': ['policies.list.filters.metal.bronze', 'Bronze'],
    '1': ['policies.list.filters.metal.catastrophic', 'Catastrophic'],
  }
  const metalLabel = (mv: string) =>
    metalLabelById[mv]
      ? f(metalLabelById[mv][0], metalLabelById[mv][1])
      : METAL_LEVELS.find((m) => m.value === mv)?.label || naValue
  const yesEmoji = '✅' // decorative, non-translatable
  const noEmoji = '❌'
  const inForceTag = ' (IN_FORCE)' // non-translatable status-code annotation
  const navigate = useNavigate()
  const user = useGetUser((s) => s.user)
  const permissions = useGetUser((s) => s.user?.permissions) || []
  const userGroups = useGetUser((s) => s.user?.groups) || []
  const canMarkAsCompleted =
    permissions && hasPermission(permissions, ALL_PERMISSIONS.MARK_COMPLETED_POLICY)
  const canExportPolicy = permissions && hasPermission(permissions, ALL_PERMISSIONS.EXPORT_POLICY)
  const canImportPolicies = permissions && hasPermission(permissions, ALL_PERMISSIONS.IMPORT_POLICIES)
  const canReassignPolicies = permissions && hasPermission(permissions, ALL_PERMISSIONS.REASSIGN_POLICY)
  const canBulkUpdatePolicies = permissions && hasPermission(permissions, ALL_PERMISSIONS.BULK_UPDATE_POLICY)
  const canViewAllPolicies =
    permissions && hasPermission(permissions, ALL_PERMISSIONS.VIEW_ALL_POLICIES)
  const canViewPolicyMemberIdCard =
    permissions && hasPermission(permissions, ALL_PERMISSIONS.VIEW_POLICY_MEMBER_ID_CARD)
  const canViewCarrierImportHistory =
    (permissions && hasPermission(permissions, ALL_PERMISSIONS.VIEW_CARRIER_IMPORT_BATCH)) ||
    userGroups.includes('Administrador') ||
    userGroups.includes('SuperAdministrador')
  const canMarkAdvisorPaid =
    userGroups.includes('Supervisor') ||
    userGroups.includes('Administrador') ||
    userGroups.includes('SuperAdministrador')
  const isAgent = userGroups.includes('Agente')
  const apolloClient = useApolloClient()

  const fetchInitialPolicyTypes = useCallback(
    () =>
      apolloClient
        .query({ query: GET_ALL_POLICY_TYPE_CATEGORIES, fetchPolicy: 'network-only' })
        .then((res) => res.data),
    [apolloClient]
  )

  const policyTypesInitCatalog = useStaticCatalog(
    'policy-type-categories',
    true,
    fetchInitialPolicyTypes
  )

  const fetchPolicyStatuses = useCallback(
    () =>
      apolloClient
        .query<AllPolicyStatusesData>({
          query: GET_ALL_POLICIES_STATUSES,
          fetchPolicy: 'network-only',
        })
        .then((res) => res.data),
    [apolloClient]
  )

  const canViewAllPolicyStatuses = hasPermission(permissions, ALL_PERMISSIONS.VIEW_POLICY_STATUS)
  const policyStatusesInitCatalog = useStaticCatalog(
    `policy-statuses:${canViewAllPolicyStatuses ? 'all' : 'agents'}`,
    true,
    fetchPolicyStatuses
  )

  const [gqlGetPolicies, { data: dataAllPolicies, loading, error, refetch }] =
    useLazyQuery<IResPoliciesAPI>(GET_ALL_POLICIES_LIST, {
      fetchPolicy: 'no-cache',
    })

  const [gqlGetPoliciesTotals, { data: dataTotals }] =
    useLazyQuery<IResPoliciesAPI>(GET_ALL_POLICIES_TOTALS, {
      fetchPolicy: 'no-cache',
    })

  const { data: dataPolicyFilters, refetch: refetchPolicyFilters } = useQuery<{
    myPolicyFilters: {
      id: string
      name: string
      scope?: string
      filters: string | PolicyFilters
      created?: string
      updated?: string
    }[]
  }>(GET_MY_POLICY_FILTERS, {
    fetchPolicy: 'network-only',
    variables: { scope: 'POLICY' },
  })

  const [gqlCreateP, { data: dataUpdate }] = useMutation<IResUpdatePolicyApi>(EDIT_POLICY)
  const [gglCompleteP, { data: dataCompleted }] = useMutation<IResCompletedPolicyApi>(COMPLETE_POLICY)
  const [gglBlockP, { data: dataBlocked }] = useMutation<IResBlockedPolicyApi>(BLOCK_POLICY)
  const [gqlMarkPoliciesPaid, { data: dataMarkPoliciesPaid, loading: loadingMarkPoliciesPaid }] =
    useMutation<IResMarkPoliciesPaidApi>(MARK_POLICIES_PAID)
  const [gqlUnpaidToAdvisor, { loading: loadingUnpaid }] = useMutation(UNPAID_TO_ADVISOR)
  const [gqlChargebackToAdvisor, { loading: loadingChargeback }] = useMutation(CHARGEBACK_TO_ADVISOR)
  const [gqlUnchargebackToAdvisor, { loading: loadingUnchargeback }] = useMutation(
    UNCHARGEBACK_TO_ADVISOR
  )
  const [gqlSyncHealthSherpa, { loading: loadingHealthSherpa }] = useMutation(SYNC_POLICY_TO_HEALTH_SHERPA)
  const [gqlCreatePolicyFilter] = useMutation(CREATE_POLICY_FILTER)
  const [gqlUpdatePolicyFilter] = useMutation(UPDATE_POLICY_FILTER)
  const [gqlDeletePolicyFilter] = useMutation(DELETE_POLICY_FILTER)

  const { isOpen: isOpenLogs, onOpen: onOpenLogs, onClose: onCloseLogs } = useDisclourse()
  const { isOpen: isOpenNotes, onOpen: onOpenNotes, onClose: onCloseNotes } = useDisclourse()
  const { isOpen: isOpenACAVerification, onOpen: onOpenACAVerification, onClose: onCloseACAVerification } = useDisclourse()
  const { isOpen: isOpenFilters, onOpen: onOpenFilters, onClose: onCloseFilters } = useDisclourse()
  const {
    isOpen: isOpenAssignPolicy,
    onOpen: onOpenAssignPolicy,
    onClose: onCloseAssignPolicy,
  } = useDisclourse()
  const {
    isOpen: isOpenQuickUpdate,
    onOpen: onOpenQuickUpdate,
    onClose: onCloseQuickUpdate,
  } = useDisclourse()
  const {
    isOpen: isOpenDuplicate,
    onOpen: onOpenDuplicate,
    onClose: onCloseDuplicate,
  } = useDisclourse()
  const {
    isOpen: isOpenReassignPolicies,
    onOpen: onOpenReassignPolicies,
    onClose: onCloseReassignPolicies,
  } = useDisclourse()
  const {
    isOpen: isOpenUpdatePolicies,
    onOpen: onOpenUpdatePolicies,
    onClose: onCloseUpdatePolicies,
  } = useDisclourse()
  const {
    isOpen: isOpenExportModal,
    onOpen: onOpenExportModal,
    onClose: onCloseExportModal,
  } = useDisclourse()
  const {
    isOpen: isOpenImportModal,
    onOpen: onOpenImportModal,
    onClose: onCloseImportModal,
  } = useDisclourse()

  const [filtersPolicies, setFiltersPolicies] = useState<
    { id: string; name: string; icon: string }[]
  >([])
  const [exportOptions, setExportOptions] = useState({
    checkPreviousYear: false,
    checkNextYear: false,
    includeMembers: false,
  })

  // const [formData, setFormData] = useState<PolicyFilters>({...INITIAL_POLICY_FILTERS})
  const [formData, setFormData] = useLocalStorage<PolicyFilters>(
    'policies-filters',
    INITIAL_POLICY_FILTERS
  )

  const parsePolicyFilterPayload = (rawFilters: string | PolicyFilters | undefined) => {
    if (!rawFilters) return INITIAL_POLICY_FILTERS
    if (typeof rawFilters === 'string') {
      try {
        const parsed = JSON.parse(rawFilters) as PolicyFilters
        return { ...INITIAL_POLICY_FILTERS, ...parsed }
      } catch {
        return INITIAL_POLICY_FILTERS
      }
    }
    return { ...INITIAL_POLICY_FILTERS, ...rawFilters }
  }

  const savedPolicyFilters: PolicySavedFilter[] =
    dataPolicyFilters?.myPolicyFilters?.map((filter) => ({
      id: filter.id,
      name: filter.name,
      created: filter.created,
      updated: filter.updated,
      filters: parsePolicyFilterPayload(filter.filters),
    })) || []

  // Función para determinar qué queries cargar basándose en los filtros aplicados
  const getFilterLoadOptions = (filters: PolicyFilters): LoadFilterOptions => {
    const getLength = (value: unknown) => {
      if (Array.isArray(value)) return value.length
      if (typeof value === 'string') return value.length
      return 0
    }

    return {
      loadUsers: getLength(filters.assignedTo) > 0,
      loadAgents: getLength(filters.user) > 0 || (filters.agentOfRecord?.length ?? 0) > 0,
      loadSignatureForms: !!filters.signatureForm,
      loadCarriers: getLength(filters.carrier) > 0,
      loadStates: getLength(filters.stateEU) > 0,
      loadPolicyTypes: getLength(filters.policyType) > 0,
      loadLeadSources: getLength(filters.leadSource) > 0,
    }
  }

  // Detectar si hay filtros aplicados y determinar qué cargar
  const initialFilterOptions = getFilterLoadOptions(formData)
  const hasAnyFilterToLoad = Object.values(initialFilterOptions).some(v => v === true)

  // Estado para controlar qué datos de filtros cargar
  // Arranca vacío para no competir con los queries críticos (lista + totales).
  // Se precarga en background después de 1.5s para que el modal abra instantáneo.
  const [filterLoadOptions, setFilterLoadOptions] = useState<LoadFilterOptions>(
    hasAnyFilterToLoad ? initialFilterOptions : {}
  )

  useEffect(() => {
    const timer = setTimeout(() => {
      setFilterLoadOptions({
        loadUsers: true,
        loadAgents: true,
        loadSignatureForms: true,
        loadCarriers: true,
        loadStates: true,
        loadPolicyTypes: true,
        loadLeadSources: true,
      })
    }, 1500)
    return () => clearTimeout(timer)
  }, [])

  const dataPolicyTypesInit = policyTypesInitCatalog.data
  if (policyTypesInitCatalog.error) toast.error(intl.formatMessage(M.errLoadPolicyTypes))

  const dataPoliciesStatuses = policyStatusesInitCatalog.data
  if (policyStatusesInitCatalog.error) toast.error(intl.formatMessage(M.errLoadPolicyStatuses))

  const {
    dataUsers,
    dataAgents,
    dataSignatureForms,
    dataCarriers,
    dataStates,
    dataPolicyTypes,
    dataLeadSources,
    loadingUsers,
    loadingAgents,
    loadingSignatureForms,
    loadingCarriers,
    loadingStates,
    loadingPolicyTypes,
    loadingLeadSources,
  } = useLoadFilterData({
    ...filterLoadOptions,
    unrestrictedAssignmentUsers: canViewAllPolicies,
  })

  const filterData = {
    users:
      dataUsers?.allUsersList?.map((u) => ({
        ...u,
        fullName: `${u.firstName} ${u.lastName}`,
      })) || [],
    agents:
      dataAgents?.allUsers.edges.map(({ node: u }) => ({
        ...u,
        fullName: `${u.firstName} ${u.lastName} - ${u.email} (${u.npn} )`,
      })) || [],
    states: dataStates?.allStatesList || [],
    signatureForms: dataSignatureForms?.allSignatureForms?.edges.map(({ node }) => node) || [],
    carriers: dataCarriers?.allInsuranceOperatorsList || [],
    policyStatuses: dataPoliciesStatuses?.allPolicyStatuses?.edges.map(({ node }) => node) || [],
    immigrationStatuses: IMMIGRATION_STATUS_CHOICES,
    leadSources: dataLeadSources?.allLeadSources?.edges.map(({ node }) => node) || [],
    // Usar dataPolicyTypesInit (siempre cargado) o dataPolicyTypes (lazy loaded)
    policyTypes: (dataPolicyTypesInit || dataPolicyTypes)?.allCategoryPolicy?.edges.map(({ node }) => node) || [],
    documentStatuses: DOCUMENT_STATUS_OPTIONS,
    paymentStatuses: PAYMENT_STATUS_OPTIONS
  }

  /*const [gqlGetCarriers, {data: carrierCategory, error: errorCarriers}] =
    useLazyQuery<AllInsuranceCategoryData>(GET_CARRIER_CATEGORY, {
      fetchPolicy: 'no-cache',
    })*/

  const [showAside, setShowAside] = useState(false)
  const { isOpen, onClose, onOpen } = useDisclourse()
  const { isOpen: isOpenPreview, onClose: onClosePreview, onOpen: onOpenPreview } = useDisclourse()
  const {
    isOpen: isOpenMemberIdCard,
    onClose: onCloseMemberIdCard,
    onOpen: onOpenMemberIdCard,
  } = useDisclourse()
  const {
    isOpen: isOpenCarrierImport,
    onClose: onCloseCarrierImport,
    onOpen: onOpenCarrierImport,
  } = useDisclourse()
  const {
    isOpen: isOpenViewBatch,
    onClose: onCloseViewBatch,
    onOpen: onOpenViewBatch,
  } = useDisclourse()
  const {
    isOpen: isOpenCarrierStatus,
    onClose: onCloseCarrierStatus,
    onOpen: onOpenCarrierStatus,
  } = useDisclourse()

  const [tabFilters, setTabFilters] = useState('Policies')
  const [selectedBatchId, setSelectedBatchId] = useState<string | null>(null)
  const [selectedCarrierStatusPolicyId, setSelectedCarrierStatusPolicyId] = useState<string | null>(null)
  const [importHistoryKey, setImportHistoryKey] = useState(0)

  const [infoPreview, setInfoPreview] = useState<null | NodePolicy>(null)
  const [dataArr, setDataArr] = useState<IResPoliciesAPI['allPolicies']['edges']>([])
  const [first, setFirst] = useState(SIZE_PAGE_DEFAULT)
  const [page, setPage] = useState(1)
  const [currentPage, setCurrentPage] = useState(1)
  const totalItems = dataAllPolicies?.allPolicies?.totalCount ?? 0
  const totalPages = Math.ceil(totalItems / first)
  const { start, end } = PaginationUtils.getPaginationRange(currentPage, first, totalItems)

  const currentYear = new Date().getFullYear()
  const lastThreeYears = [currentYear - 1, currentYear, currentYear + 1]
  const [selectedYears, setSelectedYears] = useLocalStorage<number[]>(
    'policies-selected-years',
    []
  )
  const [searchByMembers, setSearchByMembers] = useState(false)
  const [loadingExports, setLoadingExport] = useState(false)

  // Estado para el ordenamiento
  type SortColumn = 'agent' | 'client' | 'carrier' | 'status' | 'effectiveDate' | 'assignedTo' | null
  type SortDirection = 'asc' | 'desc'
  const [sortColumn, setSortColumn] = useState<SortColumn>(null)
  const [sortDirection, setSortDirection] = useState<SortDirection>('asc')

  const [totalsSnapshot, setTotalsSnapshot] = useState({
    totalPolicies: 0,
    totalApplicantsPolicies: 0,
    totalCanceled: 0,
    totalApplicantsCanceled: 0,
    totalCompleted: 0,
    totalApplicantsCompleted: 0,
    totalPending: 0,
    totalApplicantsPending: 0,
  })
  const [isFetchingTotals, setIsFetchingTotals] = useState(false)

  const prevFiltersRef = useRef({
    first,
    selectedYears: [...selectedYears],
    sortColumn,
    sortDirection,
    tabFilters,
    currentPage,
  })
  const hasInitializedRef = useRef(false)
  const pendingTotalsRequests = useRef(0)
  const skipNextFetchRef = useRef(false)

  // Mapeo de columnas frontend a backend
  const columnToBackendMap: Record<Exclude<SortColumn, null>, string> = {
    agent: 'user',
    client: 'holder',
    carrier: 'carrier',
    status: 'status',
    effectiveDate: 'effectiveDate',
    assignedTo: 'assignedTo',
  }

  interface HandleFiltersOptions {
    page?: number
    includeTotals?: boolean
    suppressAutoFetch?: boolean
    withTotals?: boolean
  }

  const handleFilters = (override?: PolicyFilters, options?: HandleFiltersOptions) => {
    const data = override ?? formData
    const targetPage = Math.max(1, options?.page ?? currentPage)

    if (options?.suppressAutoFetch) {
      skipNextFetchRef.current = true
    }

    const variables = cleanVariables({
      ...data,
      first,
      offset: (targetPage - 1) * first,
      isImportant: tabFilters === 'Important' ? true : null,
      archived: tabFilters === 'Archived' ? true : null,
      hasReminders: tabFilters === 'Reminders' ? true : null,
      hasMemberId: data.hasMemberId,
      commissionPayable: data.commissionPayable,
      commissionPaymentStatus: data.commissionPaymentStatus || null,
      ownsCar: data.ownsCar,
      ownsHome: data.ownsHome,
      hasAutoPolicy: data.hasAutoPolicy,
      hasHomePolicy: data.hasHomePolicy,
      hasCarrierAccount: data.hasCarrierAccount,
      accountCreatedByClient: data.accountCreatedByClient,
      holderName: searchByMembers ? null : data.policyName,
      memberName: searchByMembers ? data.policyName : null,
      effectiveYear: selectedYears.length > 0 ? selectedYears : null,
      insuranceCategory: data.insuranceCategory || null,
      // Transformar signatureForm y agentOfRecord de GraphQL IDs a numéricos solo para la query
      signatureForm: Array.isArray(data.signatureForm) && data.signatureForm.length > 0
        ? data.signatureForm.map((id: string) => parseId(id))
        : null,
      agentOfRecord: Array.isArray(data.agentOfRecord) && data.agentOfRecord.length > 0
        ? data.agentOfRecord.map((id: string) => parseId(id))
        : null,
      acaResult: Array.isArray(data.acaResult) && data.acaResult.length > 0
        ? (data.acaResult as string[]).join(',')
        : data.acaResult && !Array.isArray(data.acaResult)
          ? data.acaResult
          : null,
      acaValidity: data.acaValidity || null,
      orderBy: sortColumn ? columnToBackendMap[sortColumn] : null,
      orderDirection: sortColumn ? sortDirection : null,
      includeTotals: false,
    })

    gqlGetPolicies({ variables })

    if (options?.withTotals !== false) {
      pendingTotalsRef.current = { override, shouldFetch: true }
    }
  }

  const handleFetchTotals = (override?: PolicyFilters) => {
    const data = override ?? formData
    const variables = cleanVariables({
      ...data,
      isImportant: tabFilters === 'Important' ? true : null,
      archived: tabFilters === 'Archived' ? true : null,
      hasReminders: tabFilters === 'Reminders' ? true : null,
      hasMemberId: data.hasMemberId,
      commissionPayable: data.commissionPayable,
      commissionPaymentStatus: data.commissionPaymentStatus || null,
      ownsCar: data.ownsCar,
      ownsHome: data.ownsHome,
      hasAutoPolicy: data.hasAutoPolicy,
      hasHomePolicy: data.hasHomePolicy,
      hasCarrierAccount: data.hasCarrierAccount,
      accountCreatedByClient: data.accountCreatedByClient,
      holderName: searchByMembers ? null : data.policyName,
      memberName: searchByMembers ? data.policyName : null,
      effectiveYear: selectedYears.length > 0 ? selectedYears : null,
      insuranceCategory: data.insuranceCategory || null,
      signatureForm: Array.isArray(data.signatureForm) && data.signatureForm.length > 0
        ? data.signatureForm.map((id: string) => parseId(id))
        : null,
      agentOfRecord: Array.isArray(data.agentOfRecord) && data.agentOfRecord.length > 0
        ? data.agentOfRecord.map((id: string) => parseId(id))
        : null,
      acaResult: Array.isArray(data.acaResult) && data.acaResult.length > 0
        ? (data.acaResult as string[]).join(',')
        : data.acaResult && !Array.isArray(data.acaResult)
          ? data.acaResult
          : null,
      acaValidity: data.acaValidity || null,
      includeTotals: true,
    })

    pendingTotalsRequests.current += 1
    setIsFetchingTotals(true)
    const result = gqlGetPoliciesTotals({ variables })
    result?.finally(() => {
      pendingTotalsRequests.current = Math.max(pendingTotalsRequests.current - 1, 0)
      if (pendingTotalsRequests.current === 0) {
        setIsFetchingTotals(false)
      }
    })
  }

  const handlePolicyFilterErrors = (
    errors: { field?: string; message?: string }[] | undefined,
    fallback: string
  ) => {
    const message = errors?.[0]?.message || fallback
    toast.error(message)
  }

  const handleSavePolicyFilter = async (name: string, filters: PolicyFilters) => {
    const trimmedName = name.trim()
    if (!trimmedName) {
      toast.error(intl.formatMessage(M.filterNameRequired))
      return null
    }

    const result = await gqlCreatePolicyFilter({
      variables: {
        policyFilterData: {
          name: trimmedName,
          scope: 'POLICY',
          filters: JSON.stringify(filters),
        },
      },
    })

    const payload = result.data?.createPolicyFilter
    if (!payload?.success) {
      handlePolicyFilterErrors(payload?.errors, intl.formatMessage(M.unableSaveFilter))
      return null
    }

    await refetchPolicyFilters()
    toast.success(intl.formatMessage(M.filterSaved))

    if (!payload.policyFilter) return null
    return {
      id: payload.policyFilter.id,
      name: payload.policyFilter.name,
      filters: parsePolicyFilterPayload(payload.policyFilter.filters),
      updated: payload.policyFilter.updated,
    } as PolicySavedFilter
  }

  const handleUpdatePolicyFilter = async (id: string, name: string, filters: PolicyFilters) => {
    const trimmedName = name.trim()
    if (!trimmedName) {
      toast.error(intl.formatMessage(M.filterNameRequired))
      return null
    }

    const result = await gqlUpdatePolicyFilter({
      variables: {
        id: parseId(id),
        policyFilterData: {
          name: trimmedName,
          scope: 'POLICY',
          filters: JSON.stringify(filters),
        },
      },
    })

    const payload = result.data?.updatePolicyFilter
    if (!payload?.success) {
      handlePolicyFilterErrors(payload?.errors, intl.formatMessage(M.unableUpdateFilter))
      return null
    }

    await refetchPolicyFilters()
    toast.success(intl.formatMessage(M.filterUpdated))

    if (!payload.policyFilter) return null
    return {
      id: payload.policyFilter.id,
      name: payload.policyFilter.name,
      filters: parsePolicyFilterPayload(payload.policyFilter.filters),
      updated: payload.policyFilter.updated,
    } as PolicySavedFilter
  }

  const handleDeletePolicyFilter = async (id: string) => {
    const result = await gqlDeletePolicyFilter({
      variables: { id: parseId(id) },
    })

    const payload = result.data?.deletePolicyFilter
    if (!payload?.success) {
      handlePolicyFilterErrors(payload?.errors, intl.formatMessage(M.unableDeleteFilter))
      return false
    }

    await refetchPolicyFilters()
    toast.success(intl.formatMessage(M.filterDeleted))
    return true
  }

  const handleFilterApply = (filters: any) => {
    const transformedFilters = { ...filters }

    const newFormData = {
      ...formData,
      ...transformedFilters,
    }

    setFormData(newFormData)
    const shouldSuppress = currentPage !== 1
    setCurrentPage(1) // Resetear a la página 1 cuando se aplican filtros
    console.log('New Form Data:', newFormData)

    handleFilters(newFormData, { page: 1, suppressAutoFetch: shouldSuppress })
  }

  const handleDownload = async () => {
    if (!user) return
    const { token } = user
    if (!token) return
    const myHeaders = new Headers()
    myHeaders.append('Authorization', `Bearer ${token}`)

    const requestOptions = {
      method: 'GET',
      headers: myHeaders,
    }

    const params = buildPolicyExportParams(formData, selectedYears, tabFilters, searchByMembers)

    // Agregar parámetros de renovación
    if (exportOptions.checkPreviousYear) {
      params.append('checkPreviousYear', 'true')
    }
    if (exportOptions.checkNextYear) {
      params.append('checkNextYear', 'true')
    }
    if (exportOptions.includeMembers) {
      params.append('includeMembers', 'true')
    }

    setLoadingExport(true)

    try {
      const url = `${URL}/export-policies-quick-excel?${params.toString()}`
      console.log('Export URL:', url)
      const res = await fetch(url, requestOptions)
      if (!res.ok) throw new Error('Error al exportar')
      const blob = await res.blob()
      const downloadUrl = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = downloadUrl
      link.download = `policies-${moment().format('DD-MM-YY')}.xlsx`
      document.body.appendChild(link)
      setLoadingExport(false)
      link.click()
      onCloseExportModal()
    } catch (err) {
      setLoadingExport(false)
      toast.error(intl.formatMessage({ id: 'common.error.withMessage', defaultMessage: 'Error: {message}' }, { message: (err as { message: string }).message }))
    }
  }

  useEffect(() => {
    // Usar dataPolicyTypesInit para el menú lateral (carga inicial)
    const policyTypesData = dataPolicyTypesInit || dataPolicyTypes
    if (policyTypesData?.allCategoryPolicy?.edges) {
      const nuevosFiltros = policyTypesData.allCategoryPolicy.edges.flatMap(({ node }) =>
        (node.policyTypeSet?.edges || []).map(({ node: typeNode }: any) => ({
          id: typeNode.id,
          name: `${node.name} › ${typeNode.typePolicy}`,
          icon: '',
        }))
      )
      setFiltersPolicies(nuevosFiltros)
    }
  }, [dataPolicyTypesInit, dataPolicyTypes])

  const handleSelectPoliciesTab = () => {
    setCurrentPage(1)
    setTabFilters('Policies')
    if (tabFilters !== 'ImportHistory') {
      setFormData(INITIAL_POLICY_FILTERS)
    }
  }

  const handleSelectPolicyTypeTab = (id: string) => {
    setCurrentPage(1)
    setTabFilters(id)
    setFormData((prev) => ({
      ...prev,
      policyType: [parseId(id)],
    }))
  }

  const handleSelectImportantTab = () => {
    setCurrentPage(1)
    setTabFilters('Important')
    setFormData((prev) => ({ ...prev, insuranceCategory: null }))
  }

  const handleSelectRemindersTab = () => {
    setCurrentPage(1)
    setTabFilters('Reminders')
    setFormData((prev) => ({ ...prev, insuranceCategory: null }))
  }

  const handleSelectArchivedTab = () => {
    setCurrentPage(1)
    setTabFilters('Archived')
    setFormData((prev) => ({ ...prev, insuranceCategory: null }))
  }

  const handleSelectImportHistoryTab = () => {
    setCurrentPage(1)
    setTabFilters('ImportHistory')
  }

  /*useEffect(() => {
    if (errorCarriers) toast.error(intl.formatMessage({id: 'common.error.withMessage', defaultMessage: 'Error: {message}'}, {message: errorCarriers.message}))
  }, [errorCarriers])*/

  useEffect(() => {
    setPoliciesSelected([])

    if (skipNextFetchRef.current) {
      skipNextFetchRef.current = false
      prevFiltersRef.current = {
        first,
        selectedYears: [...selectedYears],
        sortColumn,
        sortDirection,
        tabFilters,
        currentPage,
      }
      hasInitializedRef.current = true
      return
    }

    if (tabFilters === 'ImportHistory') {
      prevFiltersRef.current = {
        first,
        selectedYears: [...selectedYears],
        sortColumn,
        sortDirection,
        tabFilters,
        currentPage,
      }
      hasInitializedRef.current = true
      return
    }

    const prev = prevFiltersRef.current
    const selectedYearsChanged =
      prev.selectedYears.length !== selectedYears.length ||
      prev.selectedYears.some((value, index) => value !== selectedYears[index])
    const tabChanged = prev.tabFilters !== tabFilters

    const shouldFetchTotals = !hasInitializedRef.current || tabChanged || selectedYearsChanged

    handleFilters(undefined, { withTotals: false })
    if (shouldFetchTotals) {
      handleFetchTotals()
    }

    prevFiltersRef.current = {
      first,
      selectedYears: [...selectedYears],
      sortColumn,
      sortDirection,
      tabFilters,
      currentPage,
    }
    hasInitializedRef.current = true
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [first, currentPage, selectedYears, sortColumn, sortDirection, tabFilters])

  const [policiesSelected, setPoliciesSelected] = useState<
    { id: string; name: string; status: string; user: string; agent: string }[] | undefined
  >([])

  // HealthSherpa Sync State
  const [hsSearchModalOpen, setHsSearchModalOpen] = useState(false)
  const [hsSearchResults, setHsSearchResults] = useState<any[]>([])
  const [hsAgentEmail, setHsAgentEmail] = useState<string>('')
  const [hsSelectedMember, setHsSelectedMember] = useState<any>(null)
  const [hsSearchingMemberId, setHsSearchingMemberId] = useState<string | null>(null)

  const handleSearchBeforeSync = (member: any) => {
    if (!member) return
    setHsSelectedMember(member)
    setHsSearchResults([])
    setHsAgentEmail('')
    setHsSearchModalOpen(true)
    setHsSearchingMemberId(null)
  }

  const [showConfirmPaid, setShowConfirmPaid] = useState(false)
  const [paidAt, setPaidAt] = useState<string>('')
  const [showConfirmUnpaid, setShowConfirmUnpaid] = useState(false)
  const [showConfirmChargeback, setShowConfirmChargeback] = useState(false)
  const [showConfirmUnchargeback, setShowConfirmUnchargeback] = useState(false)
  const [chargebackAt, setChargebackAt] = useState<string>('')

  const isAllSelected = policiesSelected?.length === dataAllPolicies?.allPolicies?.edges?.length

  const fullName = (p?: { firstName?: string | null; lastName?: string | null } | null) =>
    p ? [p.firstName, p.lastName].filter(Boolean).join(' ') : ''

  const toggleAll = () => {
    if (isAllSelected) {
      setPoliciesSelected([])
    } else {
      if (dataAllPolicies?.allPolicies?.edges?.length) {
        const allIds = dataAllPolicies.allPolicies.edges.map((edge) => ({
          id: edge.node.id,
          name: edge.node.policyName,
          status: edge.node.status,
          user: fullName(edge.node.user),
          agent: fullName(edge.node.assignedTo),
        }))
        setPoliciesSelected(allIds)
      }
    }
  }

  const toggleOne = (id: string) => {
    if (!id || !policiesSelected) return

    const exists = policiesSelected.find((x) => x.id === id)

    if (exists) {
      setPoliciesSelected(policiesSelected.filter((x) => x.id !== id))
    } else {
      const found = dataAllPolicies?.allPolicies?.edges.find((e) => e.node?.id === id)

      if (found?.node) {
        setPoliciesSelected([
          ...policiesSelected,
          {
            id: found.node.id,
            name: found.node.policyName,
            status: found.node.status ?? '',
            user: fullName(found.node.user),
            agent: fullName(found.node.assignedTo),
          },
        ])
      }
    }
  }

  const handleMarkPoliciesPaid = (paidAtValue?: string) => {
    if (!policiesSelected || policiesSelected.length === 0) {
      toast.info(intl.formatMessage(M.selectPaid))
      return
    }

    const paidAtIso = paidAtValue
      ? moment(paidAtValue, 'YYYY-MM-DD').startOf('day').toISOString()
      : undefined

    gqlMarkPoliciesPaid({
      variables: {
        policyIds: policiesSelected.map((policy) => parseId(policy.id)),
        paidAt: paidAtIso,
      },
    })
  }

  const handleUnpaidToAdvisor = () => {
    if (!policiesSelected || policiesSelected.length === 0) {
      toast.info(intl.formatMessage(M.selectUnpaid))
      return
    }

    gqlUnpaidToAdvisor({
      variables: {
        policyIds: policiesSelected.map((policy) => parseId(policy.id)),
      },
    })
      .then((result) => {
        const data = result.data?.unpaidToAdvisor
        if (!data) return

        const processed = data.processedCount ?? 0
        const skipped = data.skippedCount ?? 0

        if (data.success) {
          if (processed > 0) {
            toast.success(
              intl.formatMessage(M.unpaidSuccess, { processed }) + (skipped > 0 ? ' ' + intl.formatMessage(M.unpaidAlreadySuffix, { skipped }) : ''),
              { autoClose: 10000 }
            )
          } else if (skipped > 0) {
            toast.info(
              intl.formatMessage(M.unpaidAlreadyInfo, { skipped }),
              { autoClose: 10000 }
            )
          }
          refetch()
          setPoliciesSelected([])
        } else {
          // success === false
          if (data.errors && data.errors.length > 0) {
            data.errors.forEach((error: any) => {
              toast.error(error.message)
            })
          } else if (skipped > 0 && processed === 0) {
            // No errors but all skipped - inform user
            toast.info(
              intl.formatMessage(M.unpaidAlreadyInfo, { skipped }),
              { autoClose: 10000 }
            )
            refetch()
            setPoliciesSelected([])
          }
        }
      })
      .catch((error) => {
        toast.error(intl.formatMessage(M.errUnpaid, { message: error.message }))
      })
  }

  const handleChargebackToAdvisor = (chargebackAtValue: string) => {
    if (!policiesSelected || policiesSelected.length === 0) {
      toast.info(intl.formatMessage(M.selectChargeback))
      return
    }

    if (!chargebackAtValue) {
      toast.error(intl.formatMessage(M.chargebackDateRequired))
      return
    }

    const chargebackAtIso = moment(chargebackAtValue, 'YYYY-MM-DD').startOf('day').toISOString()

    gqlChargebackToAdvisor({
      variables: {
        policyIds: policiesSelected.map((policy) => parseId(policy.id)),
        chargebackAt: chargebackAtIso,
      },
    })
      .then((result) => {
        const data = result.data?.chargebackToAdvisor
        if (!data) return

        const processed = data.processedCount ?? 0
        const skipped = data.skippedCount ?? 0

        if (data.success) {
          if (processed > 0) {
            toast.success(
              intl.formatMessage(M.chargebackSuccess, { processed }) + (skipped > 0 ? ' ' + intl.formatMessage(M.chargebackAlreadySuffix, { skipped }) : ''),
              { autoClose: 10000 }
            )
          } else if (skipped > 0) {
            toast.info(
              intl.formatMessage(M.chargebackAlreadyInfo, { skipped }),
              { autoClose: 10000 }
            )
          }
          refetch()
          setPoliciesSelected([])
        } else {
          // success === false
          if (data.errors && data.errors.length > 0) {
            data.errors.forEach((error: any) => {
              toast.error(error.message)
            })
          } else if (skipped > 0 && processed === 0) {
            // No errors but all skipped - inform user
            toast.info(
              intl.formatMessage(M.chargebackAlreadyInfo, { skipped }),
              { autoClose: 10000 }
            )
            refetch()
            setPoliciesSelected([])
          }
        }
      })
      .catch((error) => {
        toast.error(intl.formatMessage(M.errChargeback, { message: error.message }))
      })
  }

  const handleUnchargebackToAdvisor = () => {
    if (!policiesSelected || policiesSelected.length === 0) {
      toast.info(intl.formatMessage(M.selectRemoveChargeback))
      return
    }

    gqlUnchargebackToAdvisor({
      variables: {
        policyIds: policiesSelected.map((policy) => parseId(policy.id)),
      },
    })
      .then((result) => {
        const data = result.data?.unchargebackToAdvisor
        if (!data) return

        const processed = data.processedCount ?? 0
        const skipped = data.skippedCount ?? 0

        if (data.success) {
          if (processed > 0) {
            toast.success(
              intl.formatMessage(M.unchargebackSuccess, { processed }) + (skipped > 0 ? ' ' + intl.formatMessage(M.unchargebackAlreadySuffix, { skipped }) : ''),
              { autoClose: 10000 }
            )
          } else if (skipped > 0) {
            toast.info(
              intl.formatMessage(M.unchargebackAlreadyInfo, { skipped }),
              { autoClose: 10000 }
            )
          }
          refetch()
          setPoliciesSelected([])
        } else {
          if (data.errors && data.errors.length > 0) {
            data.errors.forEach((error: any) => {
              toast.error(error.message)
            })
          } else if (skipped > 0 && processed === 0) {
            toast.info(
              intl.formatMessage(M.unchargebackAlreadyInfo, { skipped }),
              { autoClose: 10000 }
            )
            refetch()
            setPoliciesSelected([])
          }
        }
      })
      .catch((error) => {
        toast.error(intl.formatMessage(M.errUnchargeback, { message: error.message }))
      })
  }

  const handlePolicyName = () => {
    const shouldSuppress = currentPage !== 1
    setCurrentPage(1) // Resetear a la página 1 cuando se busca
    handleFilters(undefined, { page: 1, suppressAutoFetch: shouldSuppress })
  }

  // Refs para diferir el totalizador hasta que el listado principal termine
  const pendingTotalsRef = useRef<{ override?: PolicyFilters; shouldFetch: boolean }>({ shouldFetch: false })
  const handleFetchTotalsRef = useRef(handleFetchTotals)
  handleFetchTotalsRef.current = handleFetchTotals
  const prevLoadingRef = useRef(false)

  useEffect(() => {
    if (prevLoadingRef.current === true && loading === false) {
      if (pendingTotalsRef.current.shouldFetch) {
        handleFetchTotalsRef.current(pendingTotalsRef.current.override)
        pendingTotalsRef.current.shouldFetch = false
      }
    }
    prevLoadingRef.current = loading
  }, [loading])

  useEffect(() => {
    if (!dataAllPolicies) return
    const { edges } = dataAllPolicies.allPolicies
    setDataArr(edges)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataAllPolicies])

  useEffect(() => {
    if (!dataTotals) return
    const {
      totalPolicies,
      totalApplicantsPolicies,
      totalCanceled,
      totalApplicantsCanceled,
      totalCompleted,
      totalApplicantsCompleted,
      totalPending,
      totalApplicantsPending,
    } = dataTotals.allPolicies
    if (
      totalPolicies !== null &&
      totalApplicantsPolicies !== null &&
      totalCanceled !== null &&
      totalApplicantsCanceled !== null
    ) {
      setTotalsSnapshot({
        totalPolicies,
        totalApplicantsPolicies,
        totalCanceled,
        totalApplicantsCanceled,
        totalCompleted: totalCompleted ?? 0,
        totalApplicantsCompleted: totalApplicantsCompleted ?? 0,
        totalPending: totalPending ?? 0,
        totalApplicantsPending: totalApplicantsPending ?? 0,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataTotals])

  useEffect(() => {
    if (error) {
      pendingTotalsRequests.current = 0
      setIsFetchingTotals(false)
      toast.error(intl.formatMessage({ id: 'common.error.withMessage', defaultMessage: 'Error: {message}' }, { message: error.message }))
    }
  }, [error])

  useEffect(() => {
    if (!dataMarkPoliciesPaid) return
    const result = dataMarkPoliciesPaid.markPoliciesAsPaid
    if (result?.success) {
      const processed = result.processedCount ?? 0
      const skipped = result.skippedCount ?? 0
      toast.success(intl.formatMessage(M.paidResult, { processed, skipped }), {
        autoClose: 10000,
      })
      setPoliciesSelected([])
      handleFilters(undefined, { withTotals: false })
      if (result.errors?.length) {
        const msg = result.errors.map((e) => e?.message).filter(Boolean).join('; ')
        if (msg) toast.warn(msg, { autoClose: 10000 })
      }
    } else {
      const processed = result?.processedCount ?? 0
      const skipped = result?.skippedCount ?? 0
      const msg = result?.errors?.map((e) => e?.message).filter(Boolean).join('; ')
      toast.error(
        msg || intl.formatMessage(M.noPaidResult, { processed, skipped }),
        { autoClose: 10000 }
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataMarkPoliciesPaid])

  const updatePage = (n: number) => {
    setCurrentPage(n)
  }
  const clearFilters = () => {
    const next = { ...INITIAL_POLICY_FILTERS }
    setTabFilters('Policies') // volver a la vista principal
    setFormData(next)
    const shouldSuppress = currentPage !== 1
    setCurrentPage(1) // Resetear a la página 1 cuando se limpian filtros
    handleFilters(next, { page: 1, suppressAutoFetch: shouldSuppress })
  }

  const handleRemoveFilter = (filterKey: string | string[]) => {
    const next = { ...formData }

    // Si es un array de keys (para rangos de fechas), resetear todas
    const keysToReset = Array.isArray(filterKey) ? filterKey : [filterKey]

    keysToReset.forEach((key) => {
      // Resetear el valor del filtro según su tipo
      if (Array.isArray(next[key])) {
        next[key] = []
      } else if (typeof next[key] === 'boolean') {
        next[key] = undefined
      } else {
        next[key] = ''
      }
    })

    setFormData(next)
    const shouldSuppress = currentPage !== 1
    setCurrentPage(1) // Resetear a la página 1 cuando se remueve un filtro
    handleFilters(next, { page: 1, suppressAutoFetch: shouldSuppress })
  }

  const handleUpdatePolicy = async (id: string, data: any) => {
    gqlCreateP({
      variables: {
        id: parseId(id),
        policyData: {
          isImportant: data.isImportant,
          archivedDate: data.archivedDate,
          blockedDate: data.blockedDate,
          status: data.status,
        },
      },
    })
  }

  useEffect(() => {
    if (!dataUpdate) return
    if (dataUpdate.updatePolicy?.success) {
      toast.success(intl.formatMessage(M.policyUpdated))
      handleFilters()
    } else if (dataUpdate.updatePolicy?.errors?.length > 0) {
      toast.error(intl.formatMessage({ id: 'common.error.withMessage', defaultMessage: 'Error: {message}' }, { message: dataUpdate.updatePolicy.errors[0]?.message || intl.formatMessage(M.somethingWrong) }))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataUpdate])

  const comletePolicy = async (id: string) => {
    gglCompleteP({
      variables: {
        id: parseId(id),
      },
    })
  }

  const handleSyncHealthSherpa = async (policyId: string | number) => {
    try {
      const { data } = await gqlSyncHealthSherpa({
        variables: {
          policyId: parseInt(String(parseId(String(policyId))), 10),
        },
      })
      if (data?.syncPolicyToMedicareHealthsherpa?.success) {
        toast.success(data.syncPolicyToMedicareHealthsherpa.message || intl.formatMessage(M.syncedHs))
      } else {
        toast.error(
          data?.syncPolicyToMedicareHealthsherpa?.message || intl.formatMessage(M.errSyncHs)
        )
      }
    } catch (error) {
      toast.error(intl.formatMessage(M.errSyncHs))
    }
  }

  const blockPolicy = async (id: string) => {
    gglBlockP({
      variables: {
        id: parseId(id),
      },
    })
  }

  useEffect(() => {
    if (!dataCompleted) return
    if (dataCompleted.completePolicy?.success) {
      toast.success(intl.formatMessage(M.policyUpdated))
      handleFilters()
    } else if (dataCompleted.completePolicy?.errors?.length > 0) {
      toast.error(intl.formatMessage({ id: 'common.error.withMessage', defaultMessage: 'Error: {message}' }, { message: dataCompleted.completePolicy.errors[0]?.message || intl.formatMessage(M.somethingWrong) }))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataCompleted])


  // Póliza cuya cancelación se está confirmando: el modal pide la fecha de fin de cobertura.
  const [policyToCancel, setPolicyToCancel] = useState<string | null>(null)

  const nonEditableStatuses = ['COMPLETED', 'CANCELED']
  const InfoRow = ({
    label,
    value,
    valueClass = '',
    rowClass = '',
  }: {
    label: string
    value: React.ReactNode
    valueClass?: string
    rowClass?: string
  }) => (
    <div className={`info-row ${rowClass}`}>
      <p className='label'>{label}</p>
      <p className={`value ${valueClass}`}>{value}</p>
    </div>
  )

  // Componente para encabezados ordenables
  const SortableHeader = ({ column, children }: { column: SortColumn; children: React.ReactNode }) => {
    const isActive = sortColumn === column
    const handleSort = () => {
      if (isActive) {
        // Si ya está ordenado por esta columna, invertir la dirección
        setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc')
      } else {
        // Nueva columna, empezar en ascendente
        setSortColumn(column)
        setSortDirection('asc')
      }
    }

    return (
      <th className='fw-bold' style={{ cursor: 'pointer', userSelect: 'none' }} onClick={handleSort}>
        <div className='d-flex align-items-center gap-1'>
          {children}
          <div className='d-flex flex-column' style={{ fontSize: '0.6rem', lineHeight: '0.5' }}>
            <i
              className='bi bi-caret-up-fill'
              style={{
                color: isActive && sortDirection === 'asc' ? '#3e97ff' : '#c4c4c4',
                marginBottom: '-2px',
              }}
            />
            <i
              className='bi bi-caret-down-fill'
              style={{
                color: isActive && sortDirection === 'desc' ? '#3e97ff' : '#c4c4c4',
                marginTop: '-2px',
              }}
            />
          </div>
        </div>
      </th>
    )
  }
  // Remove any local documentVariant or paymentVariant helpers if present

  const carrierOptions = filterData.carriers.map((c) => ({ value: c.id, label: c.name }))
  const userOptions = filterData.users.map((u) => ({ value: u.id, label: u.fullName }))
  const agentsOptions = filterData.agents.map((u) => ({
    value: parseId(u.id),
    label: `${u.firstName} ${u.lastName} - ${u.email}${u.npn ? ` (${u.npn})` : ''}`,
    fullName: `${u.firstName} ${u.lastName}`,
  }))
  const formOptions = filterData.signatureForms.map((f) => ({ value: f.id, label: f.name }))
  const statusOptions = filterData.policyStatuses.map((s) => ({ value: s.code, label: s.title }))
  const leadSourcesOptions = filterData.leadSources.map((s) => ({ value: parseId(s.id), label: s.name }))
  const policyTypesOptions =
    filterData.policyTypes.flatMap((cat: any) =>
      cat.policyTypeSet?.edges?.map(({ node }: any) => ({
        value: parseId(node.id),
        label: `${cat.name} › ${node.typePolicy}`,
      })) || []
    )
  const immigrationOptions = filterData.immigrationStatuses
  const stateOptions = filterData.states.map((s) => ({
    value: s.code,
    label: `${s.name} (${s.code})`,
  }))
  // Translated option-label helpers (reuse the filters.* catalog from ModalFilters/B2).
  const yesLabel = f('common.boolean.yes', 'Yes')
  const noLabel = f('common.boolean.no', 'No')
  const DOC_STATUS_MSG: Record<string, [string, string]> = {
    ACTIVE: ['policies.list.filters.ds.active', 'Active'],
    PENDING: ['policies.list.filters.ds.pending', 'Pending'],
    PROCESSING: ['policies.list.filters.ds.processing', 'Processing'],
    DECLINED: ['policies.list.filters.ds.declined', 'Declined'],
    COMPLETED: ['policies.list.filters.ds.completed', 'Completed'],
  }
  const PAY_STATUS_MSG: Record<string, [string, string]> = {
    PAID: ['policies.list.filters.ps.paid', 'Paid'],
    FAILED: ['policies.list.filters.ps.failed', 'Failed'],
    PENDING: ['policies.list.filters.ps.pending', 'Pending'],
    AUTO_PAY: ['policies.list.filters.ps.autoPay', 'Auto Pay'],
    NOT_APPLICABLE: ['policies.list.filters.ps.notApplicable', 'Not Applicable ($0)'],
    PAGA_POR_SU_CUENTA: ['policies.list.filters.ps.pagaPorSuCuenta', 'Paga por su cuenta'],
  }
  const translateOptions = (opts: any[], map: Record<string, [string, string]>) =>
    (opts || []).map((o) => ({
      ...o,
      label: map[o.value] ? f(map[o.value][0], map[o.value][1]) : o.label,
    }))

  const signatureStatusOptions = [
    { value: 'Signed', label: f('policies.list.filters.opt.signed', 'Signed') },
    { value: 'Not Signed', label: f('policies.list.filters.opt.notSigned', 'Not Signed') },
  ]
  const documentStatusOptions = translateOptions(filterData.documentStatuses, DOC_STATUS_MSG)
  const paymentStatusOptions = translateOptions(filterData.paymentStatuses, PAY_STATUS_MSG)

  const hasMemberIdOptions = [
    { value: 'true', label: f('policies.list.filters.opt.withMemberId', 'With Member ID') },
    { value: 'false', label: f('policies.list.filters.opt.withoutMemberId', 'Without Member ID') },
  ]
  const commissionPayableOptions = [
    { value: 'true', label: f('policies.list.filters.opt.consideredCommission', 'Considered for commission') },
    { value: 'false', label: f('policies.list.filters.opt.notConsideredCommission', 'Not considered for commission') },
  ]
  const activeAcaCoverageOptions = [
    { value: 'true', label: f('policies.list.filters.opt.withoutActiveAca', 'Without an active ACA policy') },
    { value: 'false', label: f('policies.list.filters.opt.withActiveAca', 'With an active ACA policy') },
  ]
  const commissionPaymentStatusOptions = [
    { value: 'NEVER_STARTED', label: f('policies.list.filters.seg.neverStarted', 'Never Started') },
    { value: 'AT_RISK', label: f('policies.list.filters.seg.atRisk', 'At Risk') },
    { value: 'CANCELED', label: f('policies.list.filters.seg.canceled', 'Canceled') },
  ]
  const advisorPaidOptions = [
    { value: 'true', label: f('policies.list.filters.opt.paid', 'Paid') },
    { value: 'false', label: f('policies.list.filters.opt.notPaid', 'Not paid') },
  ]
  const advisorChargebackOptions = [
    { value: 'true', label: f('policies.list.filters.opt.chargeback', 'Chargeback') },
    { value: 'false', label: f('policies.list.filters.opt.noChargeback', 'No chargeback') },
  ]
  const yesNoOptions = [
    { value: 'true', label: yesLabel },
    { value: 'false', label: noLabel },
  ]

  // Helper para formatear fechas - parsea como fecha local para evitar problemas de zona horaria
  const formatDate = (dateStr: string) => {
    if (!dateStr) return ''
    // Parsear como fecha local (no UTC) para evitar que reste/sume días por diferencia horaria
    const [year, month, day] = dateStr.split('-').map(Number)
    const date = new Date(year, month - 1, day) // month es 0-indexed en JS
    return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })
  }

  const carrierStatusOptions = [
    { value: 'IN_FORCE', label: f('policies.list.filters.cs.inForce', 'In Force') },
    { value: 'TERMINATED', label: f('policies.list.filters.cs.terminated', 'Terminated') },
    { value: 'GRACE_PERIOD', label: f('policies.list.filters.cs.gracePeriod', 'Grace Period') },
    { value: 'PENDING_EFFECTUATION', label: f('policies.list.filters.cs.pendingEffectuation', 'Pending Effectuation') },
    { value: 'PAST_DUE', label: f('policies.list.filters.cs.pastDue', 'Past Due') },
    { value: 'DELINQUENT', label: f('policies.list.filters.cs.delinquent', 'Delinquent') },
    { value: 'FUTURE_EFFECTIVE', label: f('policies.list.filters.cs.futureEffective', 'Future Effective') },
    { value: 'UNKNOWN', label: f('policies.list.filters.cs.unknown', 'Unknown') },
  ]

  const filtersConfig = [
    { key: 'carrier', label: f('policies.list.filters.field.carrier', 'Carrier'), options: carrierOptions },
    { key: 'user', label: f('policies.list.filters.field.agent', 'Agent'), options: agentsOptions },
    { key: 'assignedTo', label: f('policies.list.filters.field.assignedTo', 'Assigned To'), options: userOptions },
    { key: 'signatureForm', label: f('policies.list.filters.field.signatureForm', 'Signature Form'), options: formOptions },
    { key: 'signatureStatus', label: f('policies.list.filters.field.signatureFormStatus', 'Signature Form Status'), options: signatureStatusOptions },
    { key: 'agentOfRecord', label: f('policies.list.filters.field.agentNpn', 'Agent NPN in Signature Form'), options: agentsOptions },
    { key: 'stateEU', label: f('policies.list.filters.field.state', 'State'), options: stateOptions },
    {
      key: 'stateJurisdictionType',
      label: f('policies.list.filters.field.stateJurisdictionType', 'State Jurisdiction Type'),
      options: [
        { value: 'FEDERAL', label: f('policies.list.filters.opt.federal', 'Federal') },
        { value: 'STATE', label: f('policies.list.filters.opt.stateJurisdiction', 'State') },
      ],
    },
    { key: 'status', label: f('policies.list.filters.field.policyStatus', 'Policy Status'), options: statusOptions },
    { key: 'immigrationStatus', label: f('policies.list.filters.field.immigrationStatus', 'Immigration Status'), options: immigrationOptions },
    { key: 'policyType', label: f('policies.list.filters.field.policyTypes', 'Policy Types'), options: policyTypesOptions },
    { key: 'leadSource', label: f('policies.list.filters.field.source', 'Source'), options: leadSourcesOptions },
    { key: 'metalLevel', label: f('policies.list.filters.field.metalLevel', 'Metal Level'), options: METAL_LEVELS },
    {
      key: 'documentStatus',
      label: f('policies.list.filters.field.documentStatus', 'Document Status'),
      options: documentStatusOptions,
    },
    {
      key: 'paymentStatus',
      label: f('policies.list.filters.field.paymentStatus', 'Payment status'),
      options: paymentStatusOptions,
    },
    {
      key: 'hasMemberId',
      label: f('policies.list.filters.field.memberIdStatus', 'Member ID Status'),
      options: hasMemberIdOptions,
      transform: (value: boolean) => value ? f('policies.list.filters.opt.withMemberId', 'With Member ID') : f('policies.list.filters.opt.withoutMemberId', 'Without Member ID'),
    },
    {
      key: 'commissionPayable',
      label: f('policies.list.filters.field.commissionReportStatus', 'Commission Report Status'),
      options: commissionPayableOptions,
      transform: (value: boolean) => value ? f('policies.list.filters.opt.consideredCommission', 'Considered for commission') : f('policies.list.filters.opt.notConsideredCommission', 'Not considered for commission'),
    },
    {
      key: 'withoutActiveAcaPolicy',
      label: f('policies.list.filters.field.activeAcaCoverage', 'Active ACA coverage'),
      options: activeAcaCoverageOptions,
      transform: (value: boolean) => value
        ? f('policies.list.filters.opt.withoutActiveAca', 'Without an active ACA policy')
        : f('policies.list.filters.opt.withActiveAca', 'With an active ACA policy'),
    },
    {
      key: 'commissionPaymentStatus',
      label: f('policies.list.filters.field.commissionPaymentStatus', 'Commission Payment Status'),
      options: commissionPaymentStatusOptions,
    },
    {
      key: 'advisorPaid',
      label: f('policies.list.filters.field.advisorPaymentStatus', 'Advisor Payment Status'),
      options: advisorPaidOptions,
      transform: (value: boolean) => value ? f('policies.list.filters.opt.paid', 'Paid') : f('policies.list.filters.opt.notPaid', 'Not paid'),
    },
    {
      key: 'advisorChargeback',
      label: f('policies.list.filters.field.chargebackStatus', 'Chargeback Status'),
      options: advisorChargebackOptions,
      transform: (value: boolean) => value ? f('policies.list.filters.opt.chargeback', 'Chargeback') : f('policies.list.filters.opt.noChargeback', 'No chargeback'),
    },
    {
      key: 'ownsCar',
      label: f('policies.list.filters.field.ownsCar', 'Owns car'),
      options: yesNoOptions,
      transform: (value: boolean) => value ? yesLabel : noLabel,
    },
    {
      key: 'ownsHome',
      label: f('policies.list.filters.field.ownsHome', 'Owns home'),
      options: yesNoOptions,
      transform: (value: boolean) => value ? yesLabel : noLabel,
    },
    {
      key: 'hasAutoPolicy',
      label: f('policies.list.filters.field.hasAutoPolicy', 'Has auto policy'),
      options: yesNoOptions,
      transform: (value: boolean) => value ? yesLabel : noLabel,
    },
    {
      key: 'hasHomePolicy',
      label: f('policies.list.filters.field.hasHomePolicy', 'Has home policy'),
      options: yesNoOptions,
      transform: (value: boolean) => value ? yesLabel : noLabel,
    },
    {
      key: 'hasCarrierAccount',
      label: f('policies.list.filters.field.hasCarrierAccount', 'Has carrier account'),
      options: yesNoOptions,
      transform: (value: boolean) => value ? yesLabel : noLabel,
    },
    {
      key: 'accountCreatedByClient',
      label: f('policies.list.filters.field.accountCreatedByClient', 'Account created by client'),
      options: yesNoOptions,
      transform: (value: boolean) => value ? yesLabel : noLabel,
    },
    {
      key: 'accountCreatedByClient',
      label: f('policies.list.filters.field.accountCreatedByClient', 'Account created by client'),
      options: yesNoOptions,
      transform: (value: boolean) => value ? yesLabel : noLabel,
    },
    {
      key: 'unassigned',
      label: f('policies.list.filters.field.unassignedPolicies', 'Unassigned Policies'),
      options: [
        { value: 'true', label: f('policies.list.filters.opt.onlyUnassigned', 'Only unassigned') },
        { value: 'false', label: f('policies.list.filters.opt.onlyAssigned', 'Only assigned') },
      ],
      transform: (value: boolean) => value ? f('policies.list.filters.opt.onlyUnassigned', 'Only unassigned') : f('policies.list.filters.opt.onlyAssigned', 'Only assigned'),
    },
    {
      key: 'carrierStatusGeneric',
      label: f('policies.list.filters.field.carrierStatus', 'Carrier Status'),
      options: carrierStatusOptions,
    },
    {
      key: 'carrierIsAgeIn',
      label: f('policies.list.filters.field.ageIn', 'Age-In'),
      options: yesNoOptions,
      transform: (value: boolean) => value ? yesLabel : noLabel,
    },
    {
      key: 'carrierIsDelinquent',
      label: f('policies.list.filters.field.delinquent', 'Delinquent'),
      options: yesNoOptions,
      transform: (value: boolean) => value ? yesLabel : noLabel,
    },
    {
      key: 'carrierIsUnpaidPending',
      label: f('policies.list.filters.field.unpaidPending', 'Unpaid Pending'),
      options: yesNoOptions,
      transform: (value: boolean) => value ? yesLabel : noLabel,
    },
    {
      key: 'carrierIsUnpaidPastDue',
      label: f('policies.list.filters.field.unpaidPastDue', 'Unpaid Past Due'),
      options: yesNoOptions,
      transform: (value: boolean) => value ? yesLabel : noLabel,
    },
    {
      key: 'carrierNoImportData',
      label: f('policies.list.filters.field.noCarrierImport', 'No Carrier Import'),
      options: yesNoOptions,
      transform: (value: boolean) => value ? yesLabel : noLabel,
    },
    {
      key: 'acaValidity',
      label: f('policies.list.filters.field.acaValidity', 'ACA Validity'),
      options: [
        { value: 'active', label: f('policies.list.filters.acaVal.d28', '≤ 28 days left (any active)') },
        { value: 'days_21', label: f('policies.list.filters.acaVal.d21', '≤ 21 days left') },
        { value: 'days_14', label: f('policies.list.filters.acaVal.d14', '≤ 14 days left') },
        { value: 'days_7', label: f('policies.list.filters.acaVal.d7', '≤ 7 days left') },
        { value: 'days_3', label: f('policies.list.filters.acaVal.d3', '≤ 3 days left') },
        { value: 'none', label: f('policies.list.filters.acaVal.none', 'No active verification') },
      ],
    },
  ]

  // Filtros de rangos de fechas - se manejan por pares
  const dateRangeFilters = [
    {
      keyFrom: 'effectiveDateAfter',
      keyTo: 'effectiveDateBefore',
      label: f('policies.list.filters.dateRange.effective', 'Effective Date'),
    },
    {
      keyFrom: 'createdAfter',
      keyTo: 'createdBefore',
      label: f('policies.list.filters.dateRange.created', 'Created Date'),
    },
    {
      keyFrom: 'documentsDueDateAfter',
      keyTo: 'documentsDueDateBefore',
      label: f('policies.list.filters.dateRange.documentsDue', 'Documents Due Date'),
    },
    {
      keyFrom: 'canceledAfter',
      keyTo: 'canceledBefore',
      label: f('policies.list.filters.dateRange.cancellation', 'Cancellation Date'),
    },
    {
      keyFrom: 'paymentStatusDateAfter',
      keyTo: 'paymentStatusDateBefore',
      label: f('policies.list.filters.dateRange.paymentStatus', 'Payment Status Date'),
    },
    {
      keyFrom: 'advisorPaidDateAfter',
      keyTo: 'advisorPaidDateBefore',
      label: f('policies.list.filters.dateRange.advisorPaid', 'Advisor Paid Date'),
    },
    {
      keyFrom: 'advisorChargebackDateAfter',
      keyTo: 'advisorChargebackDateBefore',
      label: f('policies.list.filters.dateRange.advisorChargeback', 'Advisor Chargeback Date'),
    },
    {
      keyFrom: 'carrierLastAsOfDateAfter',
      keyTo: 'carrierLastAsOfDateBefore',
      label: f('policies.list.filters.dateRange.carrierAsOf', 'Carrier As-of Date'),
    },
  ]
  return (
    <div className='policies-page'>
      <header className='header'>
        <Breadcrumb>
          <Breadcrumb.Item className='d-blok d-md-none' onClick={() => setShowAside(true)}>
            <span>
              <i className='bi bi-list fs-1' />
            </span>
          </Breadcrumb.Item>
          <Breadcrumb.Item className='fs-3'>{intl.formatMessage(M.wordPolicies)}</Breadcrumb.Item>
          {/* <Breadcrumb.Item active>Quote </Breadcrumb.Item> */}
        </Breadcrumb>

        <div className='d-flex align-items-center gap-2'>
          {tabFilters !== 'ImportHistory' && canImportPolicies && (
            <Button className='btn-sm btn-outline' variant='outline-primary' onClick={onOpenImportModal}>
              <i className='bi bi-upload'></i> {intl.formatMessage(M.btnImport)}
            </Button>
          )}
          {tabFilters !== 'ImportHistory' && canExportPolicy && (
            <Button
              disabled={loadingExports}
              className='btn-sm btn-outline btn-export'
              onClick={onOpenExportModal}
            >
              {loadingExports ? (
                <Spinner animation='border' size='sm' />
              ) : (
                <i className='bi bi-download'></i>
              )} {intl.formatMessage(M.btnExport)}
            </Button>
          )}
          {tabFilters !== 'ImportHistory' && canReassignPolicies && (
            <Button size='sm' onClick={onOpenReassignPolicies}>
              <i className='bi bi-person-up fs-3' /> {intl.formatMessage(M.btnReassign)}
            </Button>
          )}
          {tabFilters !== 'ImportHistory' && canBulkUpdatePolicies && (
            <Button size='sm' variant='secondary' onClick={onOpenUpdatePolicies}>
              <i className='bi bi-pencil-square fs-3' /> {(policiesSelected?.length || 0) > 0
                ? intl.formatMessage(M.btnUpdateCount, { count: policiesSelected?.length })
                : intl.formatMessage(M.btnUpdate)}
            </Button>
          )}
          {tabFilters !== 'ImportHistory' && (
            <Button size='sm' onClick={onOpen}>
              <i className='bi bi-plus fs-3' /> {intl.formatMessage(M.btnNewPolicy)}
            </Button>
          )}
          {tabFilters !== 'ImportHistory' && canMarkAdvisorPaid && (policiesSelected?.length || 0) > 0 && (
            <Button
              size='sm'
              variant='success'
              style={{ color: 'black' }}
              onClick={() => {
                setPaidAt(moment().format('YYYY-MM-DD'))
                setShowConfirmPaid(true)
              }}
              disabled={loadingMarkPoliciesPaid}
            >
              {loadingMarkPoliciesPaid
                ? intl.formatMessage(M.btnMarking)
                : intl.formatMessage(M.btnMarkPaidCount, { count: policiesSelected?.length || 0 })}
            </Button>
          )}
          {canMarkAdvisorPaid &&
            (policiesSelected?.length || 0) > 0 &&
            policiesSelected?.every(p => {
              const policy = dataAllPolicies?.allPolicies?.edges?.find(e => e.node.id === p.id)
              return policy?.node.advisorPaid === true
            }) && (
              <>
                <Button
                  size='sm'
                  variant='warning'
                  style={{ color: 'black' }}
                  onClick={() => setShowConfirmUnpaid(true)}
                  disabled={loadingUnpaid}
                >
                  {loadingUnpaid ? intl.formatMessage(M.btnProcessing) : intl.formatMessage(M.btnUnpaidCount, { count: policiesSelected?.length || 0 })}
                </Button>
                <Button
                  size='sm'
                  variant='danger'
                  onClick={() => {
                    setChargebackAt(moment().format('YYYY-MM-DD'))
                    setShowConfirmChargeback(true)
                  }}
                  disabled={loadingChargeback}
                >
                  {loadingChargeback ? intl.formatMessage(M.btnProcessing) : intl.formatMessage(M.btnChargebackCount, { count: policiesSelected?.length || 0 })}
                </Button>
              </>
            )}
          {canMarkAdvisorPaid &&
            (policiesSelected?.length || 0) > 0 &&
            policiesSelected?.every((p) => {
              const policy = dataAllPolicies?.allPolicies?.edges?.find((e) => e.node.id === p.id)
              return policy?.node.advisorChargeback === true
            }) && (
              <Button
                size='sm'
                variant='outline-danger'
                onClick={() => setShowConfirmUnchargeback(true)}
                disabled={loadingUnchargeback}
              >
                {loadingUnchargeback ? intl.formatMessage(M.btnProcessing) : intl.formatMessage(M.btnUnchargebackCount, { count: policiesSelected?.length || 0 })}
              </Button>
            )}
        </div>
      </header>
      <Row className='policies'>
        <Col md={3} lg={3} sm={0} xl={3} className='menu'>
          <div className='menu-aside'>
            <div className='title'>
              <h5 style={{ fontSize: '13px' }}>{intl.formatMessage(M.menuTitle)}</h5>
            </div>
            <div className='list-menu'>
              <ListGroup variant='flush'>
                <ListGroup.Item
                  action
                  variant={tabFilters === 'Policies' ? 'primary' : 'light'}
                  onClick={handleSelectPoliciesTab}
                >
                  <i className='bi bi-person-fill fs-3' style={{ color: 'inherit' }} /> {intl.formatMessage(M.wordPolicies)}
                </ListGroup.Item>

                {filtersPolicies.length > 0 &&
                  filtersPolicies.map((lis) => (
                    <ListGroup.Item
                      key={lis.name}
                      className='filters-favorites'
                      action
                      variant={tabFilters === lis.id ? 'primary' : 'light'}
                      onClick={() => handleSelectPolicyTypeTab(lis.id)}
                    >
                      {lis.icon && (
                        <i
                          className={`bi bi-${lis.icon} fs-3`}
                          style={{ color: 'inherit', marginRight: '8px' }}
                        />
                      )}
                      {lis.name}
                    </ListGroup.Item>
                  ))}

                <ListGroup.Item
                  action
                  variant={tabFilters === 'Important' ? 'primary' : 'light'}
                  onClick={handleSelectImportantTab}
                >
                  <i className='bi bi-star-fill fs-3' style={{ color: 'inherit' }} /> {intl.formatMessage(M.menuImportant)}
                </ListGroup.Item>
                <ListGroup.Item
                  action
                  variant={tabFilters === 'Reminders' ? 'primary' : 'light'}
                  onClick={handleSelectRemindersTab}
                >
                  <i className='bi bi-clock fs-3' style={{ color: 'inherit' }} /> {intl.formatMessage(M.menuReminders)}
                </ListGroup.Item>
                <ListGroup.Item
                  action
                  variant={tabFilters === 'Archived' ? 'primary' : 'light'}
                  onClick={handleSelectArchivedTab}
                >
                  <i className='bi bi-folder-fill fs-3' style={{ color: 'inherit' }} /> {intl.formatMessage(M.menuArchived)}
                </ListGroup.Item>
                {canViewCarrierImportHistory && (
                  <ListGroup.Item
                    action
                    variant={tabFilters === 'ImportHistory' ? 'primary' : 'light'}
                    onClick={handleSelectImportHistoryTab}
                  >
                    <i className='bi bi-cloud-upload fs-3' style={{ color: 'inherit' }} /> {intl.formatMessage(M.menuImportHistory)}
                  </ListGroup.Item>
                )}
              </ListGroup>
            </div>
          </div>
        </Col>
        <Col md={8} lg={8} sm={12} xl={9} className='container'>
          <div className='policies-container'>
            {tabFilters !== 'ImportHistory' && (
              <>
                <div className='policies-summary d-flex justify-content-between'>
                  <Card className='card-summary blue flex-fill mx-2 text-center'>
                    <h3>{intl.formatMessage(M.wordPolicies)}</h3>
                    <Card.Title>{intl.formatMessage(M.cardAllPolicies)}</Card.Title>
                    <Card.Body>
                      {isFetchingTotals && <Spinner animation='border' />}
                      {totalsSnapshot.totalPolicies}
                      <div className='card-summary-sub'>
                        {totalsSnapshot.totalApplicantsPolicies} {intl.formatMessage(M.applicants)}
                      </div>
                    </Card.Body>
                  </Card>
                  <Card className='card-summary green flex-fill mx-2 text-center'>
                    <h3>{intl.formatMessage(M.cardCompleted)}</h3>
                    <Card.Title>{intl.formatMessage(M.cardCompletedPolicies)}</Card.Title>
                    <Card.Body>
                      {isFetchingTotals && <Spinner animation='border' />}
                      {totalsSnapshot.totalCompleted}
                      <div className='card-summary-sub'>
                        {totalsSnapshot.totalApplicantsCompleted} {intl.formatMessage(M.applicants)}
                      </div>
                    </Card.Body>
                  </Card>
                  <Card className='card-summary pending flex-fill mx-2 text-center'>
                    <h3>{intl.formatMessage(M.cardInProcess)}</h3>
                    <Card.Title>{intl.formatMessage(M.cardInProcessPolicies)}</Card.Title>
                    <Card.Body>
                      {isFetchingTotals && <Spinner animation='border' />}
                      {totalsSnapshot.totalPending}
                      <div className='card-summary-sub'>
                        {totalsSnapshot.totalApplicantsPending} {intl.formatMessage(M.applicants)}
                      </div>
                    </Card.Body>
                  </Card>
                  <Card className='card-summary canceled flex-fill mx-2 text-center'>
                    <h3>{intl.formatMessage(M.cardCanceled)}</h3>
                    <Card.Title>{intl.formatMessage(M.cardCanceledPolicies)}</Card.Title>
                    <Card.Body>
                      {isFetchingTotals && <Spinner animation='border' />}
                      {totalsSnapshot.totalCanceled}
                      <div className='card-summary-sub'>
                        {totalsSnapshot.totalApplicantsCanceled} {intl.formatMessage(M.applicants)}
                      </div>
                    </Card.Body>
                  </Card>
                </div>
                <div className='title-header'>
                  <h3>{intl.formatMessage(M.wordPolicies)}</h3>
                  <div className='filter-by-years'>
                    {dataArr.length > 0 && <span className='fw-bold me-4'>{intl.formatMessage(M.effectiveYear)}</span>}
                    {lastThreeYears &&
                      lastThreeYears.length > 0 &&
                      lastThreeYears.map((year) => (
                        <Form.Check
                          key={year}
                          inline
                          label={year}
                          checked={selectedYears.includes(year)}
                          onChange={() => {
                            setCurrentPage(1)
                            setSelectedYears(
                              (prev) =>
                                prev.includes(year)
                                  ? prev.filter((y) => y !== year)
                                  : [...prev, year]
                            )
                          }}
                        />
                      ))}
                  </div>
                </div>
                <div className='filters-header'>
                  <div className='line1'>
                    <InputGroup>
                      <Form.Control
                        placeholder={intl.formatMessage(M.phQuery)}
                        aria-label={intl.formatMessage(M.ariaSearch)}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            policyName: e.target.value,
                          }))
                        }
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            e.preventDefault() // evita el submit automático
                            handlePolicyName() // si tienes una función como esa
                          }
                        }}
                        value={formData.policyName}
                      />
                      <Button
                        onClick={() => {
                          const shouldSuppress = currentPage !== 1
                          setCurrentPage(1) // Resetear a la página 1 cuando se hace clic en Search
                          handleFilters(undefined, { page: 1, suppressAutoFetch: shouldSuppress })
                        }}
                        variant='outline-success'
                        style={{ border: '1px solid #dbdfe9' }}
                      >
                        {intl.formatMessage(M.btnSearch)}
                      </Button>
                      <Button
                        variant='outline-primary'
                        style={{ border: '1px solid #dbdfe9' }}
                        onClick={onOpenFilters}
                      >
                        {intl.formatMessage(M.btnFilter)}
                      </Button>
                    </InputGroup>
                  </div>
                  <div className='line2'>
                    <Form.Check
                      type='checkbox'
                      checked={searchByMembers}
                      onChange={(e) => setSearchByMembers(e.target.checked)}
                      label={
                        <span>
                          {intl.formatMessage(M.searchByMembers)} <span className='ms-2 ' data-tooltip-id='my-tooltip-info-1'>
                            <i className='bi bi-question-circle-fill text-primary' />
                          </span>
                          <Tooltip
                            id='my-tooltip-info-1'
                            place='bottom'
                            style={{
                              zIndex: 99999,
                              backgroundColor: 'white',
                              color: 'black',
                              boxShadow:
                                'rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px',
                            }}
                          >
                            <div className='tooltip-tfi'>
                              <p style={{ color: '#222' }}>
                                {intl.formatMessage(M.searchByMembersTooltip)}
                              </p>
                            </div>
                          </Tooltip>
                        </span>
                      }
                    />
                    <AppliedFiltersList
                      filters={formData}
                      config={filtersConfig}
                      dateRangeFilters={dateRangeFilters}
                      formatDate={formatDate}
                      clearFilters={clearFilters}
                      onRemoveFilter={handleRemoveFilter}
                    />
                  </div>
                </div>
              </>
            )}
            {tabFilters === 'ImportHistory' && canViewCarrierImportHistory ? (
              <CarrierImportHistory
                key={importHistoryKey}
                onOpenCarrierImport={onOpenCarrierImport}
                onViewDetails={(batchId) => {
                  setSelectedBatchId(batchId)
                  onOpenViewBatch()
                }}
              />
            ) : (
              <>
                <div className='results-header'>
                  <PaginationSection
                    first={first}
                    setFirst={(n) => {
                      setFirst(n)
                      setPage(1)
                      // setOffset(0)
                    }}
                    currentPage={currentPage}
                    totalPages={totalPages}
                    start={start}
                    end={end}
                    totalPolicies={totalItems}
                    updatePage={updatePage}
                    PaginationUtils={PaginationUtils}
                  />
                  <div className='col-md-3'>
                    <div className='results-filter'>
                      <Col lg={12} md={12} sm={12} xs={12}></Col>
                    </div>
                  </div>
                </div>
                <div className='table-responsive table table-striped table-hover '>
                  <table
                    className='table-scrollable table-scroll  table table-striped table-hover '
                    style={{ whiteSpace: 'nowrap' }}
                  >
                    <thead>
                      <tr role='row'>
                        <th>
                          <input
                            className='form-check-input'
                            type='checkbox'
                            checked={isAllSelected}
                            onChange={toggleAll}
                          />
                        </th>
                        <SortableHeader column='agent'>
                          <span style={{ fontSize: '0.85em', lineHeight: '1.2' }}>
                            <FormattedMessage {...M.thAgentOwner} values={{ br: <br /> }} />
                          </span>
                        </SortableHeader>
                        <SortableHeader column='client'>{intl.formatMessage(M.thClient)}</SortableHeader>
                        <SortableHeader column='carrier'>{intl.formatMessage(M.thPolicy)}</SortableHeader>
                        <SortableHeader column='status'>{f('common.field.status', 'Status')}</SortableHeader>
                        <SortableHeader column='assignedTo'>{f('policies.list.filters.field.assignedTo', 'Assigned To')}</SortableHeader>
                        <th className='fw-bold'>{intl.formatMessage(M.thAgentOfRecord)}</th>
                        {tabFilters === 'Archived' && <th className='fw-bold'>{intl.formatMessage(M.menuArchived)}</th>}
                        {FEATURE_SHOW_EZLYNX_COLUMN && (
                          <th className='fw-bold text-center' style={{ minWidth: '110px' }}>{ezlynx}</th>
                        )}
                        <th className='fw-bold'>{f('common.field.actions', 'Actions')}</th>
                      </tr>
                    </thead>
                    {loading || !dataAllPolicies ? (
                      <tbody>
                        {Array.from({ length: 10 }).map((_, i) => (
                          <tr key={i} className='placeholder-glow'>
                            <td>
                              <span className='placeholder rounded' style={{ width: 18, height: 18, display: 'inline-block' }} />
                            </td>
                            <td>
                              <span className='placeholder rounded-circle' style={{ width: 40, height: 40, display: 'inline-block' }} />
                            </td>
                            <td>
                              <span className='placeholder rounded' style={{ width: 130, display: 'inline-block' }} />
                              <br />
                              <span className='placeholder rounded mt-1' style={{ width: 90, display: 'inline-block' }} />
                            </td>
                            <td>
                              <span className='placeholder rounded' style={{ width: 110, display: 'inline-block' }} />
                              <br />
                              <span className='placeholder rounded mt-1' style={{ width: 130, display: 'inline-block' }} />
                              <br />
                              <span className='placeholder rounded mt-1' style={{ width: 55, height: 20, display: 'inline-block' }} />
                            </td>
                            <td>
                              <span className='placeholder rounded-pill' style={{ width: 80, height: 24, display: 'inline-block' }} />
                            </td>
                            <td>
                              <span className='placeholder rounded' style={{ width: 100, display: 'inline-block' }} />
                            </td>
                            <td>
                              <span className='placeholder rounded' style={{ width: 100, display: 'inline-block' }} />
                            </td>
                            <td>
                              <span className='placeholder rounded' style={{ width: 80, height: 24, display: 'inline-block' }} />
                            </td>
                            <td>
                              <span className='placeholder rounded' style={{ width: 60, height: 28, display: 'inline-block' }} />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    ) : (
                      <tbody>
                        {dataArr.length === 0 && (
                          <tr>
                            <td colSpan={9}>
                              <div className='d-flex flex-center' style={{ height: '30vh' }}>
                                {intl.formatMessage(M.emptyNoPolicies)}
                              </div>
                            </td>
                          </tr>
                        )}
                        {dataArr
                          .slice(first * page - first, first * page)
                          .map(({ node: nodePolicy }, index) => (
                            <tr key={nodePolicy.id + '_' + index}>
                              <td>
                                <div className='set-quick-status'>
                                  <div className='set-important'>
                                    <i
                                      style={{
                                        color: nodePolicy.isImportant ? 'gold' : 'inherit',
                                        cursor: 'pointer',
                                      }}
                                      className='bi bi-star-fill fs-3'
                                      onClick={(e) => {
                                        e.stopPropagation()
                                        nodePolicy.isImportant = !nodePolicy.isImportant
                                        handleUpdatePolicy(nodePolicy.id, {
                                          isImportant: nodePolicy.isImportant,
                                        })
                                      }}
                                    />
                                  </div>
                                  <div>
                                    <input
                                      className='form-check-input'
                                      type='checkbox'
                                      checked={policiesSelected?.some(
                                        (item) => item.id === nodePolicy.id
                                      )}
                                      onClick={(e) => {
                                        e.stopPropagation()
                                      }}
                                      onChange={(e) => {
                                        e.stopPropagation()
                                        toggleOne(nodePolicy?.id)
                                      }}
                                    />
                                  </div>
                                </div>
                              </td>
                              <td>
                                <div>
                                  <UserAvatar
                                    user={nodePolicy.user}
                                    tooltipId={`myt${nodePolicy.id}`}
                                    size={45}
                                  />
                                  <AgentInfoTooltip id={`myt${nodePolicy.id}`} user={nodePolicy.user} />
                                </div>
                              </td>
                              <td>
                                <InfoClientPolicy
                                  id={nodePolicy.id}
                                  holder={nodePolicy.holderMember}
                                  policy={nodePolicy}
                                  isQuote={false}
                                />
                              </td>
                              <td className='limit-width'>
                                <div className='info-policy-name'>
                                  <span
                                    className='text-primary text-link fw-bold'
                                    style={{ cursor: 'pointer' }}
                                    data-tooltip-id={`myt2${parseId(nodePolicy.id)}`}
                                  >
                                    {nodePolicy.carrier?.name || nrValue}
                                  </span>
                                  {/* En ACA el plan ya se identifica por metal level y CMS plan id;
                                      en el resto de los productos el nombre del plan es el dato que
                                      distingue una póliza de otra. Se trunca por ancho y el título
                                      nativo muestra el nombre completo al pasar el mouse. */}
                                  {!isAcaKind(getPolicyFormKind(nodePolicy.typePolicy)) &&
                                    nodePolicy.planName && (
                                      <p
                                        className='m-0 p-0 text-muted'
                                        style={{
                                          fontSize: '0.95rem',
                                          maxWidth: '260px',
                                          overflow: 'hidden',
                                          textOverflow: 'ellipsis',
                                          whiteSpace: 'nowrap',
                                        }}
                                        title={nodePolicy.planName}
                                      >
                                        {nodePolicy.planName}
                                      </p>
                                    )}
                                  <p className='m-0 p-0' style={{ fontSize: '0.95rem' }}>
                                    {intl.formatMessage(M.cellEffective, { date: moment(nodePolicy.effectiveDate).format('MMM DD, YYYY') })}
                                  </p>
                                  <div className='d-flex align-items-center gap-2 mt-1'>
                                    <Badge
                                      bg='primary'
                                      className='d-flex align-items-center gap-1 text-white'
                                      title={intl.formatMessage(M.titleApplicants, { count: nodePolicy.applicants || 0 })}
                                    >
                                      <i className='bi bi-people-fill' />
                                      {nodePolicy.applicants || 0}
                                    </Badge>
                                    {nodePolicy.memberId && (
                                      <span className='m-0 p-0' style={{ fontSize: '0.95rem' }}>
                                        {intl.formatMessage(M.cellMemberId, { id: nodePolicy.memberId })}
                                      </span>
                                    )}
                                    {nodePolicy.hasAutoPolicy === true ? (
                                      <Badge
                                        bg='success'
                                        className='d-flex align-items-center text-white'
                                        title={f('policies.list.filters.field.hasAutoPolicy', 'Has auto policy')}
                                      >
                                        <i className='bi bi-car-front-fill' style={{ color: 'var(--bs-white)' }} />
                                      </Badge>
                                    ) : nodePolicy.ownsCar === true ? (
                                      <Badge
                                        bg='danger'
                                        className='d-flex align-items-center text-white'
                                        title={f('policies.list.filters.field.ownsCar', 'Owns car')}
                                      >
                                        <i className='bi bi-car-front-fill' style={{ color: 'var(--bs-white)' }} />
                                      </Badge>
                                    ) : null}
                                    {nodePolicy.hasHomePolicy === true ? (
                                      <Badge
                                        bg='success'
                                        className='d-flex align-items-center text-white'
                                        title={f('policies.list.filters.field.hasHomePolicy', 'Has home policy')}
                                      >
                                        <i className='bi bi-house-fill' style={{ color: 'var(--bs-white)' }} />
                                      </Badge>
                                    ) : nodePolicy.ownsHome === true ? (
                                      <Badge
                                        bg='danger'
                                        className='d-flex align-items-center text-white'
                                        title={f('policies.list.filters.field.ownsHome', 'Owns home')}
                                      >
                                        <i className='bi bi-house-fill' style={{ color: 'var(--bs-white)' }} />
                                      </Badge>
                                    ) : null}
                                    {nodePolicy.hasCarrierAccount === true ? (
                                      <Badge
                                        bg={nodePolicy.accountCreatedByClient === true ? 'info' : 'success'}
                                        className='d-flex align-items-center justify-content-center text-white'
                                        style={{ width: '1.5rem', height: '1.5rem', padding: 0 }}
                                        title={
                                          nodePolicy.accountCreatedByClient === true
                                            ? f('policies.list.filters.field.hasCarrierAccount.createdByClient', 'Has carrier account (created by client)')
                                            : f('policies.list.filters.field.hasCarrierAccount', 'Has carrier account')
                                        }
                                      >
                                        <i className='bi bi-link-45deg' style={{ color: 'var(--bs-white)', fontSize: '1.1rem' }} />
                                      </Badge>
                                    ) : null}
                                    {/* {isMedicareEligiblePolicy(nodePolicy) && (
                                  <div className="d-flex align-items-center gap-2">
                                    {nodePolicy.holderMember?.healthsherpaContactId ? (
                                      <Badge bg="success" className="text-white" title="Synced to HealthSherpa">
                                        <i className="fa fa-check-circle mr-1"></i>
                                        HS Synced
                                      </Badge>
                                    ) : (
                                      <Button
                                        variant="outline-info"
                                        size="sm"
                                        className="sync-hs-button btn-xs py-0 px-2"
                                        onClick={() => handleSearchBeforeSync(nodePolicy.holderMember)}
                                        disabled={hsSearchingMemberId === nodePolicy.holderMember?.id}
                                      >
                                        {hsSearchingMemberId === nodePolicy.holderMember?.id ? (
                                          <Spinner animation="border" size="sm" />
                                        ) : (
                                          <>
                                            <i className="fa fa-sync-alt mr-1"></i>
                                            Sync HS
                                          </>
                                        )}
                                      </Button>
                                    )}
                                  </div>
                                )} */}
                                  </div>
                                  <Tooltip
                                    clickable={true}
                                    delayHide={500}
                                    id={`myt2${parseId(nodePolicy.id)}`}
                                    place='top'
                                    className='tooltip-tfi tooltip-clean'
                                  >
                                    <div className='tooltip-content'>
                                      <h6 className='text-center'>{intl.formatMessage(M.tooltipMoreInfo)}</h6>

                                      <InfoRow label={intl.formatMessage(M.irProduct)} value={intl.formatMessage(M.irProductValue)} />
                                      <InfoRow label={intl.formatMessage(M.irPlan)} value='' />
                                      <InfoRow label='' value={nodePolicy.planName || nrValue} />
                                      <InfoRow
                                        label={intl.formatMessage(M.irMetal)}
                                        value={metalLabel(String(nodePolicy.metalLevel))}
                                      />
                                      <InfoRow label={intl.formatMessage(M.irPremium)} value={`$${nodePolicy.premium}`} />
                                      <InfoRow label={intl.formatMessage(M.irNpn)} value={nodePolicy.NPN || naValue} />
                                      <InfoRow
                                        label={intl.formatMessage(M.irBlocked)}
                                        value={nodePolicy.blockedDate ? `${yesEmoji} ${f('common.boolean.yes', 'Yes')}` : `${noEmoji} ${f('common.boolean.no', 'No')}`}
                                        valueClass={
                                          nodePolicy.blockedDate ? 'text-success' : 'text-danger'
                                        }
                                      />
                                      <InfoRow
                                        label={intl.formatMessage(M.irIsDuplicate)}
                                        value={nodePolicy.isDuplicated ? `${yesEmoji} ${f('common.boolean.yes', 'Yes')}` : `${noEmoji} ${f('common.boolean.no', 'No')}`}
                                        valueClass={
                                          nodePolicy.isDuplicated ? 'text-success' : 'text-danger'
                                        }
                                      />
                                      <InfoRow
                                        label={intl.formatMessage(M.irSubmitted)}
                                        value={moment(nodePolicy.created).format('DD MMM, YY HH:mm')}
                                      />
                                      <InfoRow
                                        label={intl.formatMessage(M.irLastUpdate)}
                                        value={moment(nodePolicy.updated).format('DD MMM, YY HH:mm')}
                                      />
                                    </div>
                                  </Tooltip>
                                </div>
                              </td>

                              <td>
                                <div>
                                  <BadgeStatePolicy
                                    status={getTitleByStatus(
                                      dataPoliciesStatuses?.allPolicyStatuses.edges ?? [],
                                      nodePolicy.status
                                    )}
                                    color={getColorByStatus(
                                      dataPoliciesStatuses?.allPolicyStatuses.edges ?? [],
                                      nodePolicy.status
                                    )}
                                  />
                                  <span className='d-block'>
                                    {intl.formatMessage(M.cellDocuments)} <Badge
                                      className='badge-sm'
                                      bg={getDocumentVariant(nodePolicy.stateDocs)}
                                      text={getBadgeTextColor(getDocumentVariant(nodePolicy.stateDocs))}
                                    >
                                      {nodePolicy.stateDocs || naValue}
                                    </Badge>
                                  </span>
                                  {nodePolicy.documentsDueDate && (
                                    <span className='d-block'>
                                      {intl.formatMessage(M.cellDocsDue)} <Badge
                                        className='badge-sm'
                                        bg={
                                          moment(nodePolicy.documentsDueDate).startOf('day').isBefore(moment().startOf('day'))
                                            ? 'danger'
                                            : 'warning'
                                        }
                                        text={
                                          moment(nodePolicy.documentsDueDate).startOf('day').isBefore(moment().startOf('day'))
                                            ? 'white'
                                            : 'dark'
                                        }
                                      >
                                        {moment(nodePolicy.documentsDueDate).format('MMM DD, YYYY')}
                                      </Badge>
                                    </span>
                                  )}
                                  <span>
                                    {intl.formatMessage(M.cellPayment)} <Badge
                                      className='badge-sm'
                                      bg={getPaymentVariant(nodePolicy.paymentStatus)}
                                      text={getBadgeTextColor(getPaymentVariant(nodePolicy.paymentStatus))}
                                    >
                                      {nodePolicy.paymentStatus || naValue}
                                    </Badge>
                                  </span>
                                  {nodePolicy.carrierStatusGeneric && (
                                    <span className='d-block'>
                                      {intl.formatMessage(M.cellCarrier)} <Badge
                                        className='badge-sm'
                                        bg={getCarrierStatusVariant(nodePolicy.carrierStatusGeneric)}
                                        text={getBadgeTextColor(
                                          getCarrierStatusVariant(nodePolicy.carrierStatusGeneric)
                                        )}
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => {
                                          setSelectedCarrierStatusPolicyId(String(parseId(nodePolicy.id)))
                                          onOpenCarrierStatus()
                                        }}
                                      >
                                        {nodePolicy.carrierStatusGeneric === 'IN_FORCE' &&
                                          nodePolicy.carrierStatusRaw
                                          ? nodePolicy.carrierStatusRaw + inForceTag
                                          : (nodePolicy.carrierStatusRaw || nodePolicy.carrierStatusGeneric)}
                                      </Badge>
                                      {nodePolicy.carrierIsAgeIn && (
                                        <Badge className='badge-sm ms-1' bg='info' text='white'>{intl.formatMessage(M.cellAgeIn)}</Badge>
                                      )}
                                      {nodePolicy.carrierIsDelinquent && nodePolicy.carrierStatusGeneric !== 'DELINQUENT' && (
                                        <Badge className='badge-sm ms-1' bg='warning' text='dark'>{intl.formatMessage(M.cellDlq)}</Badge>
                                      )}
                                      {nodePolicy.carrierLastAsOfDate && (
                                        <small className='d-block ms-5 mt-1'>
                                          <span>{intl.formatMessage(M.cellAsOf)}</span> <span style={{ color: '#000' }}>
                                            {moment(nodePolicy.carrierLastAsOfDate).format('MMM DD, YYYY')}
                                          </span>
                                        </small>
                                      )}
                                    </span>
                                  )}
                                </div>
                              </td>
                              <td>
                                <div style={{
                                  maxWidth: '150px',
                                  minWidth: '120px',
                                  wordBreak: 'break-word',
                                  whiteSpace: 'normal',
                                  lineHeight: '1.3'
                                }}>
                                  {nodePolicy.assignedTo?.firstName} {nodePolicy.assignedTo?.lastName}
                                  {nodePolicy.advisorPaid && (
                                    <div className='mt-1'>
                                      <Badge bg='success' className='badge-sm'>
                                        {intl.formatMessage(M.cellPaidToAdvisor)}
                                      </Badge>
                                      {nodePolicy.advisorPaidAt && (
                                        <div style={{ fontSize: '0.85rem' }}>
                                          {moment(nodePolicy.advisorPaidAt).format('MMM DD, YYYY')}
                                        </div>
                                      )}
                                    </div>
                                  )}
                                  {nodePolicy.advisorChargeback && (
                                    <div className='mt-1'>
                                      <Badge bg='danger' className='badge-sm' style={{ color: 'white' }}>
                                        {intl.formatMessage(M.cellChargeback)}
                                      </Badge>
                                      {nodePolicy.advisorChargebackAt && (
                                        <div style={{ fontSize: '0.85rem' }}>
                                          {moment(nodePolicy.advisorChargebackAt).format('MMM DD, YYYY')}
                                        </div>
                                      )}
                                    </div>
                                  )}
                                  {(() => {
                                    const aca = nodePolicy.latestAcaVerification
                                    if (!aca?.result || !aca?.created) return null
                                    const daysElapsed = (Date.now() - new Date(aca.created).getTime()) / 86400000
                                    if (daysElapsed > 28) return null
                                    const daysLeft = Math.ceil(28 - daysElapsed)
                                    const ACA_RESULT_CONFIG: Record<string, { label: string; bg: string; textClass: string }> = {
                                      green: { label: f('policies.list.filters.aca.green', 'Paid & Completed'), bg: '#198754', textClass: 'text-white' },
                                      yellow: { label: f('policies.list.filters.aca.yellow', 'Paid / Pending Documents'), bg: '#ffc107', textClass: 'text-dark' },
                                      red: { label: f('policies.list.filters.aca.red', 'Unpaid / Pending'), bg: '#dc3545', textClass: 'text-white' },
                                      blue: { label: f('policies.list.filters.aca.blue', '$0 Premium / Completed'), bg: '#0d6efd', textClass: 'text-white' },
                                    }
                                    const cfg = ACA_RESULT_CONFIG[aca.result.toLowerCase()]
                                    if (!cfg) return null
                                    return (
                                      <div className='mt-1'>
                                        <span
                                          className={`badge badge-sm ${cfg.textClass}`}
                                          style={{ backgroundColor: cfg.bg }}
                                        >
                                          {intl.formatMessage(M.cellAcaPrefix, { label: cfg.label })}
                                        </span>
                                        <div
                                          style={{
                                            fontSize: '0.78rem',
                                            color: daysLeft <= 5 ? '#dc3545' : '#6c757d',
                                            fontWeight: daysLeft <= 5 ? 600 : 400,
                                          }}
                                        >
                                          {intl.formatMessage(M.daysLeft, { count: daysLeft })}
                                        </div>
                                      </div>
                                    )
                                  })()}
                                </div>
                              </td>
                              <td>
                                <div style={{
                                  maxWidth: '150px',
                                  minWidth: '120px',
                                  wordBreak: 'break-word',
                                  whiteSpace: 'normal',
                                  lineHeight: '1.3'
                                }}>
                                  {nodePolicy.agentOfRecord || ''}
                                </div>
                              </td>
                              {tabFilters === 'Archived' && (
                                <td>{moment(nodePolicy.archivedDate).format('DD MMM, YY')}</td>
                              )}

                              {/* EZLynx Sync Column */}
                              {FEATURE_SHOW_EZLYNX_COLUMN && (
                                <td className='text-center align-middle'>
                                  {nodePolicy.lead?.id ? (
                                    <EZLynxSyncBadge leadId={nodePolicy.lead.id} showButton={false} />
                                  ) : (
                                    <span className='text-muted fs-8'>{emDash}</span>
                                  )}
                                </td>
                              )}

                              <td>
                                <Dropdown as={ButtonGroup}>
                                  <Button
                                    variant='outline-primary'
                                    size='sm'
                                    style={{ border: '1px solid #3e97ff' }}
                                    onClick={() => {
                                      onOpenPreview()
                                      setInfoPreview(nodePolicy)
                                    }}
                                  >
                                    {intl.formatMessage(M.actPreview)}
                                  </Button>
                                  <Dropdown.Toggle
                                    split
                                    variant='outline-primary'
                                    size='sm'
                                    id='dropdown-custom-2'
                                    style={{ border: '1px solid #3e97ff' }}
                                  />
                                  <Dropdown.Menu className='dropdown-menu-policy'>
                                    {canViewPolicyMemberIdCard && (
                                      <>
                                        <Dropdown.Item
                                          onClick={() => {
                                            onOpenMemberIdCard()
                                            setInfoPreview(nodePolicy)
                                          }}
                                        >
                                          <i className='bi bi-credit-card-2-front' /> {intl.formatMessage(M.actGetMemberIdCard)}
                                        </Dropdown.Item>
                                        <Dropdown.Divider />
                                      </>
                                    )}
                                    {isMedicareEligiblePolicy(nodePolicy) && (
                                      <>
                                        <Dropdown.Item
                                          onClick={(e) => {
                                            e.stopPropagation()
                                            handleSyncHealthSherpa(nodePolicy.id)
                                          }}
                                          disabled={loadingHealthSherpa}
                                        >
                                          {loadingHealthSherpa ? (
                                            <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className='me-2' />
                                          ) : (
                                            <i className='bi bi-cloud-arrow-up text-primary' />
                                          )} {intl.formatMessage(M.actSyncHs)}
                                        </Dropdown.Item>
                                        <Dropdown.Divider />
                                      </>
                                    )}
                                    {!nonEditableStatuses.includes(nodePolicy.status) &&
                                      canMarkAsCompleted && (
                                        <Dropdown.Item
                                          onClick={(e) => {
                                            e.stopPropagation()
                                            comletePolicy(nodePolicy.id)
                                          }}
                                        >
                                          <i
                                            className='bi bi-check-circle-fill fs-2'
                                            style={{ color: 'green' }}
                                          />
                                          {intl.formatMessage(M.actMarkCompleted)}
                                        </Dropdown.Item>
                                      )}
                                    <Dropdown.Divider />
                                    {nodePolicy.blockedDate === null ? (
                                      <Dropdown.Item
                                        onClick={(e) => {
                                          e.stopPropagation()
                                          const blockedDateStr = new Date().toISOString()
                                          nodePolicy.blockedDate = blockedDateStr
                                          handleUpdatePolicy(nodePolicy.id, {
                                            blockedDate: blockedDateStr,
                                          })
                                        }}
                                      >
                                        <i className='bi bi-folder-fill' /> {intl.formatMessage(M.actMarkBlocked)}
                                      </Dropdown.Item>
                                    ) : (
                                      <Dropdown.Item
                                        onClick={(e) => {
                                          e.stopPropagation()
                                          nodePolicy.blockedDate = ''
                                          handleUpdatePolicy(nodePolicy.id, {
                                            blockedDate: null,
                                          })
                                        }}
                                      >
                                        <i className='bi bi-folder-fill' /> {intl.formatMessage(M.actMarkUnblocked)}
                                      </Dropdown.Item>
                                    )}
                                    <Dropdown.Item
                                      onClick={() => navigate(`/one-policy/${parseId(nodePolicy.id)}`)}
                                    >
                                      <i className='bi bi-pencil-fill' /> {intl.formatMessage(M.actEdit)}
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                      onClick={() => {
                                        onOpenDuplicate()
                                        setInfoPreview(nodePolicy)
                                      }}
                                    >
                                      <i className='bi bi-collection-fill' /> {intl.formatMessage(M.actDuplicate)}
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                      onClick={() => {
                                        onOpenQuickUpdate()
                                        setInfoPreview(nodePolicy)
                                      }}
                                    >
                                      <i className='bi bi-arrow-repeat' /> {intl.formatMessage(M.actQuickUpdate)}
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                      onClick={() => {
                                        onOpenAssignPolicy()
                                        setInfoPreview(nodePolicy)
                                      }}
                                    >
                                      <i className='bi bi-person-check' /> {intl.formatMessage(M.actAssignPolicy)}
                                    </Dropdown.Item>
                                    <Dropdown.Item eventKey='6'>
                                      <i className='bi bi-arrow-repeat' /> {intl.formatMessage(M.actAddReminder)}
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                      onClick={() => {
                                        setInfoPreview(nodePolicy)
                                        onOpenNotes()
                                      }}
                                    >
                                      <i className='bi bi-pencil-square' /> {intl.formatMessage(M.actAddNote)}
                                    </Dropdown.Item>
                                    {nodePolicy.lead?.id && (
                                      <>
                                        <Dropdown.Divider />
                                        <EZLynxSyncBadge
                                          leadId={nodePolicy.lead.id}
                                          showButton={true}
                                        />
                                      </>
                                    )}
                                    <Dropdown.Item
                                      onClick={() => {
                                        setInfoPreview(nodePolicy)
                                        onOpenLogs()
                                      }}
                                    >
                                      <i className='bi bi-list-columns-reverse' /> {intl.formatMessage(M.actViewLogs)}
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                      onClick={() => {
                                        setInfoPreview(nodePolicy)
                                        onOpenACAVerification()
                                      }}
                                    >
                                      <i className='bi bi-clipboard2-check' /> {intl.formatMessage(M.actAcaVerification)}
                                    </Dropdown.Item>
                                    {!nonEditableStatuses.includes(nodePolicy.status) &&
                                      nodePolicy.archivedDate === null && (
                                        <>
                                          <Dropdown.Divider />
                                          <Dropdown.Item
                                            onClick={(e) => {
                                              e.stopPropagation()
                                              const archivedDateStr = new Date().toISOString()
                                              nodePolicy.archivedDate = archivedDateStr
                                              handleUpdatePolicy(nodePolicy.id, {
                                                archivedDate: archivedDateStr,
                                              })
                                            }}
                                          >
                                            <i className='bi bi-folder-fill' /> {intl.formatMessage(M.actMarkArchived)}
                                          </Dropdown.Item>
                                        </>
                                      )}
                                    {!nonEditableStatuses.includes(nodePolicy.status) &&
                                      nodePolicy.archivedDate !== null && (
                                        <>
                                          <Dropdown.Divider />
                                          <Dropdown.Item
                                            onClick={(e) => {
                                              e.stopPropagation()
                                              nodePolicy.archivedDate = ''
                                              handleUpdatePolicy(nodePolicy.id, {
                                                archivedDate: null,
                                              })
                                            }}
                                          >
                                            <i className='bi bi-folder-fill' /> {intl.formatMessage(M.actMarkUnarchived)}
                                          </Dropdown.Item>
                                        </>
                                      )}
                                    {nodePolicy.status !== 'CANCELED' && canMarkAsCompleted && (
                                      <>
                                        <Dropdown.Item
                                          onClick={(e) => {
                                            e.stopPropagation()
                                            // Cancelar exige fijar la fecha en que termina la
                                            // cobertura, asi que va por el modal y no directo.
                                            setPolicyToCancel(nodePolicy.id)
                                          }}
                                        >
                                          <i
                                            className='bi bi-x-circle-fill fs-2'
                                            style={{ color: 'red' }}
                                          />
                                          {intl.formatMessage(M.actMarkCancel)}
                                        </Dropdown.Item>
                                      </>
                                    )}
                                  </Dropdown.Menu>
                                </Dropdown>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    )}
                  </table>
                </div>
              </>
            )}
          </div>
        </Col>
      </Row>

      {showAside && (
        <AsideMenuPolicies
          isOpen={showAside}
          onClose={() => setShowAside(false)}
          tabFilters={tabFilters}
          filtersPolicies={filtersPolicies}
          canViewCarrierImportHistory={canViewCarrierImportHistory}
          onSelectPolicies={handleSelectPoliciesTab}
          onSelectPolicyType={handleSelectPolicyTypeTab}
          onSelectImportant={handleSelectImportantTab}
          onSelectReminders={handleSelectRemindersTab}
          onSelectArchived={handleSelectArchivedTab}
          onSelectImportHistory={handleSelectImportHistoryTab}
        />
      )}

      {isOpen && (
        <ModalAddPolice
          refetch={refetch}
          isOpen={isOpen}
          onClose={onClose}
          keyboard={false}
          backdrop='static'
        />
      )}
      {isOpenImportModal && (
        <ModalImportPolicies
          isOpen={isOpenImportModal}
          onClose={onCloseImportModal}
          onImported={() => refetch()}
        />
      )}
      {isOpenPreview && infoPreview && (
        <ModalPreview
          id={infoPreview.id}
          isOpen={isOpenPreview}
          onClose={onClosePreview}
          statusColor={getColorByStatus(
            dataPoliciesStatuses?.allPolicyStatuses.edges ?? [],
            infoPreview.status
          )}
        />
      )}
      {isOpenMemberIdCard && infoPreview && (
        <ModalMemberIdCard id={infoPreview.id} isOpen={isOpenMemberIdCard} onClose={onCloseMemberIdCard} />
      )}
      {isOpenFilters && (
        <ModalFilters
          isOpen={isOpenFilters}
          onClose={onCloseFilters}
          onApply={handleFilterApply}
          savedFilters={savedPolicyFilters}
          onSaveFilter={handleSavePolicyFilter}
          onUpdateFilter={handleUpdatePolicyFilter}
          onDeleteFilter={handleDeletePolicyFilter}
          setFilters={setFormData}
          filters={formData}
          users={filterData.users}
          agents={filterData.agents}
          states={filterData.states}
          immigrationStatuses={filterData.immigrationStatuses}
          signatureForms={filterData.signatureForms}
          carriers={filterData.carriers}
          policyStatuses={filterData.policyStatuses}
          documentStatuses={filterData.documentStatuses}
          paymentStatuses={filterData.paymentStatuses}
          policyTypes={filterData.policyTypes}
          leadSources={filterData.leadSources}
          isLoading={
            (filterLoadOptions.loadUsers && loadingUsers) ||
            (filterLoadOptions.loadAgents && loadingAgents) ||
            (filterLoadOptions.loadCarriers && loadingCarriers) ||
            (filterLoadOptions.loadStates && loadingStates) ||
            (filterLoadOptions.loadSignatureForms && loadingSignatureForms) ||
            (filterLoadOptions.loadPolicyTypes && loadingPolicyTypes) ||
            (filterLoadOptions.loadLeadSources && loadingLeadSources)
          }
          isAgent={isAgent}
        />
      )}
      {isOpenCarrierImport && (
        <ModalUpdatePoliciesByCarrier
          isOpen={isOpenCarrierImport}
          onClose={onCloseCarrierImport}
          onSuccess={() => {
            refetch?.()
            setImportHistoryKey(prev => prev + 1) // Force refresh Import History
          }}
          carriers={filterData.carriers}
          policyStatuses={filterData.policyStatuses}
          policyTypes={filterData.policyTypes}
        />
      )}
      {infoPreview && isOpenQuickUpdate && (
        <ModalQuickUpdates
          node={infoPreview}
          isOpen={isOpenQuickUpdate}
          onClose={onCloseQuickUpdate}
          refetch={refetch}
        />
      )}
      {infoPreview && isOpenAssignPolicy && (
        <ModalAssignAgentPolicy
          id={infoPreview.id}
          isOpen={isOpenAssignPolicy}
          onClose={onCloseAssignPolicy}
          refetch={refetch}
          typeAssign={'ASSIGN_TO'}
        />
      )}
      {infoPreview && isOpenNotes && (
        <ModalNotes isOpen={isOpenNotes} onClose={onCloseNotes} idPolicy={String(parseId(infoPreview.id))} />
      )}
      {infoPreview && isOpenLogs && (
        <ModalViewLogs isOpen={isOpenLogs} onClose={onCloseLogs} id={infoPreview.id} />
      )}
      {policyToCancel && (
        <ModalCancelPolicy
          id={policyToCancel}
          isOpen={!!policyToCancel}
          onClose={() => setPolicyToCancel(null)}
          refetch={handleFilters}
        />
      )}
      {infoPreview && isOpenACAVerification && (
        <ModalACAVerification
          isOpen={isOpenACAVerification}
          onClose={onCloseACAVerification}
          policyId={infoPreview.id}
          documentsDueDate={infoPreview.documentsDueDate}
          hasOpenTickets={false}
          members={infoPreview.memberPolicySet?.edges || []}
        />
      )}
      {infoPreview && isOpenDuplicate && (
        <ModalDuplicatePolicy
          id={infoPreview.id}
          isOpen={isOpenDuplicate}
          onClose={onCloseDuplicate}
          refetch={refetch}
        />
      )}
      {isOpenReassignPolicies && (
        <ModalReassignPolicies
          isOpen={isOpenReassignPolicies}
          onClose={onCloseReassignPolicies}
          updateListPolicies={refetch}
          filters={formData}
          tabFilters={tabFilters}
          selectedYears={selectedYears}
          searchByMembers={searchByMembers}
          filtersConfig={filtersConfig}
          dateRangeFilters={dateRangeFilters}
          formatDate={formatDate}
        />
      )}
      {isOpenUpdatePolicies && (
        <ModalUpdatePolicies
          isOpen={isOpenUpdatePolicies}
          onClose={onCloseUpdatePolicies}
          updateListPolicies={refetch}
          filters={formData}
          tabFilters={tabFilters}
          selectedYears={selectedYears}
          searchByMembers={searchByMembers}
          totalItems={totalItems}
          policyStatuses={filterData.policyStatuses}
          policyTypeOptions={policyTypesOptions.map((o) => ({ value: Number(o.value), label: o.label }))}
          carrierOptions={carrierOptions.map((o) => ({ value: Number(parseId(o.value)), label: o.label }))}
          filtersConfig={filtersConfig}
          dateRangeFilters={dateRangeFilters}
          formatDate={formatDate}
          selectedPolicies={policiesSelected || []}
        />
      )}
      {selectedBatchId && (
        <ModalViewCarrierImportBatch
          show={isOpenViewBatch}
          onClose={onCloseViewBatch}
          batchId={selectedBatchId}
          policyStatuses={filterData.policyStatuses || []}
        />
      )}
      {selectedCarrierStatusPolicyId && (
        <ModalCarrierStatusDetails
          show={isOpenCarrierStatus}
          onClose={onCloseCarrierStatus}
          policyId={selectedCarrierStatusPolicyId}
        />
      )}
      <Modal show={showConfirmPaid} onHide={() => setShowConfirmPaid(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>{intl.formatMessage(M.confirmPaidTitle)}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {intl.formatMessage(M.confirmPaidBody, { count: policiesSelected?.length || 0 })}
          <div className='mt-3'>
            <Form.Label>{intl.formatMessage(M.fieldPaidDate)}</Form.Label>
            <Form.Control
              type='date'
              value={paidAt}
              onChange={(e) => setPaidAt(e.target.value)}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={() => setShowConfirmPaid(false)}>
            {intl.formatMessage(M.cancel)}
          </Button>
          <Button
            variant='success'
            onClick={() => {
              setShowConfirmPaid(false)
              handleMarkPoliciesPaid(paidAt)
            }}
            disabled={loadingMarkPoliciesPaid}
          >
            {intl.formatMessage(M.btnConfirm)}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal Unpaid to Advisor */}
      <Modal show={showConfirmUnpaid} onHide={() => setShowConfirmUnpaid(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>{intl.formatMessage(M.confirmUnpaidTitle)}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{intl.formatMessage(M.confirmUnpaidBody, { count: policiesSelected?.length || 0 })}</p>
          <p className='text-muted' style={{ fontSize: '0.9rem' }}>
            {intl.formatMessage(M.confirmUnpaidNote, { count: policiesSelected?.length || 0 })}
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={() => setShowConfirmUnpaid(false)}>
            {intl.formatMessage(M.cancel)}
          </Button>
          <Button
            variant='warning'
            onClick={() => {
              setShowConfirmUnpaid(false)
              handleUnpaidToAdvisor()
            }}
            disabled={loadingUnpaid}
          >
            {intl.formatMessage(M.btnConfirmUnpaid)}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal Chargeback to Advisor */}
      <Modal show={showConfirmChargeback} onHide={() => setShowConfirmChargeback(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>{intl.formatMessage(M.confirmChargebackTitle)}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{intl.formatMessage(M.confirmChargebackBody, { count: policiesSelected?.length || 0 })}</p>
          <div className='mt-3'>
            <Form.Label>{intl.formatMessage(M.fieldChargebackDate)}</Form.Label>
            <Form.Control
              type='date'
              value={chargebackAt}
              onChange={(e) => setChargebackAt(e.target.value)}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={() => setShowConfirmChargeback(false)}>
            {intl.formatMessage(M.cancel)}
          </Button>
          <Button
            variant='danger'
            onClick={() => {
              setShowConfirmChargeback(false)
              handleChargebackToAdvisor(chargebackAt)
            }}
            disabled={loadingChargeback}
          >
            {intl.formatMessage(M.btnConfirmChargeback)}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal Remove Chargeback */}
      <Modal show={showConfirmUnchargeback} onHide={() => setShowConfirmUnchargeback(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>{intl.formatMessage(M.confirmRemoveTitle)}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{intl.formatMessage(M.confirmRemoveBody, { count: policiesSelected?.length || 0 })}</p>
          <p className='text-muted' style={{ fontSize: '0.9rem' }}>
            {intl.formatMessage(M.confirmRemoveNote, { count: policiesSelected?.length || 0 })}
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={() => setShowConfirmUnchargeback(false)}>
            {intl.formatMessage(M.cancel)}
          </Button>
          <Button
            variant='danger'
            onClick={() => {
              setShowConfirmUnchargeback(false)
              handleUnchargebackToAdvisor()
            }}
            disabled={loadingUnchargeback}
          >
            {intl.formatMessage(M.btnConfirmRemove)}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal de Exportación */}
      <Modal show={isOpenExportModal} onHide={onCloseExportModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>{intl.formatMessage(M.exportTitle)}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className='mb-3'>
              <Form.Check
                type='checkbox'
                id='checkPreviousYear'
                label={intl.formatMessage(M.exportPrevYear)}
                checked={exportOptions.checkPreviousYear}
                onChange={(e) =>
                  setExportOptions({ ...exportOptions, checkPreviousYear: e.target.checked })
                }
              />
              <Form.Text className='text-muted'>
                {intl.formatMessage(M.exportPrevYearHint, { nextYear: String(moment().year() + 1), year: String(moment().year()) })}
              </Form.Text>
            </Form.Group>
            <Form.Group className='mb-3'>
              <Form.Check
                type='checkbox'
                id='checkNextYear'
                label={intl.formatMessage(M.exportNextYear)}
                checked={exportOptions.checkNextYear}
                onChange={(e) =>
                  setExportOptions({ ...exportOptions, checkNextYear: e.target.checked })
                }
              />
              <Form.Text className='text-muted'>
                {intl.formatMessage(M.exportNextYearHint, { year: String(moment().year()), nextYear: String(moment().year() + 1) })}
              </Form.Text>
            </Form.Group>
            <Form.Group className='mb-3'>
              <Form.Check
                type='checkbox'
                id='includeMembers'
                label={intl.formatMessage(M.exportIncludeMembers)}
                checked={exportOptions.includeMembers}
                onChange={(e) =>
                  setExportOptions({ ...exportOptions, includeMembers: e.target.checked })
                }
              />
              <Form.Text className='text-muted'>
                {intl.formatMessage(M.exportIncludeMembersHint)}
              </Form.Text>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={onCloseExportModal}>
            {intl.formatMessage(M.cancel)}
          </Button>
          <Button variant='primary' onClick={handleDownload} disabled={loadingExports}>
            {loadingExports ? (
              <>
                <Spinner animation='border' size='sm' /> {intl.formatMessage(M.btnExporting)}
              </>
            ) : (
              <>
                <i className='bi bi-download'></i> {intl.formatMessage(M.btnExport)}
              </>
            )}
          </Button>
        </Modal.Footer>
      </Modal>
      {hsSelectedMember && (
        <ModalHealthSherpaSearch
          isOpen={hsSearchModalOpen}
          onClose={() => setHsSearchModalOpen(false)}
          member={hsSelectedMember}
          searchResults={hsSearchResults}
          agentEmail={hsAgentEmail}
          onSuccess={() => {
            // Refetch to update status
            refetch()
          }}
        />
      )}
    </div>
  )
}
